// src/i18n.js
/* jshint esversion: 6 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "Free Call": "Free Call",
      "Online Support": "Online Support",
      "Our Location": "Our Location",
      "Language": "Language",
      "Notification": "Notification",
      "Messages": "Messages",
      "Bookings": "Bookings",
      "Favorites": "Favorites",
      "Wallet": "Wallet",
      "Account": "Account",
      "Log out": "Log out",
      "Enable Location Services": "Enable Location Services",
      "To provide accurate services, please enable your location.": "To provide accurate services, please enable your location.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Allow location access when prompted. If not prompted, enable it in your browser settings.",
      "Refresh the page after enabling.": "Refresh the page after enabling.",
      "Enable Now": "Enable Now",
      "Discover amazing event": "Discover amazing event",
      "Search here...": "Search here...",
      "Reviews": "Reviews",
      "Browse by Category": "Browse by Category",
      "Latest Event": "Latest Event",
      "Just Dropped – Be the First to Book!": "Just Dropped – Be the First to Book!",
      "Nearby Event": "Nearby Event",
      "Happening Around You – Don’t Miss Out!": "Happening Around You – Don’t Miss Out!",
      "Monthly Event": "Monthly Event",
      "This Month’s Top Picks – Plan Your Fun!": "This Month’s Top Picks – Plan Your Fun!",
      "View Details": "View Details",
      "Upcoming Event": "Upcoming Event",
      "Coming Soon – Save Your Spot Early!": "Coming Soon – Save Your Spot Early!",
      "Instant Ticket Delivery": "Instant Ticket Delivery",
      "Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!": "Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!",
      "Easy Cancellations": "Easy Cancellations",
      "Change of plans? Cancel or reschedule your booking within 15 days with flexible options.": "Change of plans? Cancel or reschedule your booking within 15 days with flexible options.",
      "24/7 Customer Support": "24/7 Customer Support",
      "Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.": "Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.",
      "Secure Payment": "Secure Payment",
      "Book your tickets safely using multiple secure payment methods, including credit and debit cards.": "Book your tickets safely using multiple secure payment methods, including credit and debit cards.",
      "About Company": "About Company",
      "We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.": "We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.",
      "Help Information": "Help Information",
      "Shipping Information": "Shipping Information",
      "Return & Refunds": "Return & Refunds",
      "Payment Options": "Payment Options",
      "FAQ": "FAQ",
      "Terms of Service": "Terms of Service",
      "Account Information": "Account Information",
      "Login/Create Accoun": "Login/Create Accoun",
      "Track Order": "Track Order",
      "Copyright © 2025 Nabhiverse, All Rights Reserved.": "Copyright © 2025 Nabhiverse, All Rights Reserved.",
      "Home": "Home",
      "Event Not Available !!": "Event Not Available !!",
      "Ticket Price": "Ticket Price",
      "Organized By": "Organized By",
      "Attendees": "Attendees",
      "Chat": "Chat",
      "About Event": "About Event",
      "Disclaimer": "Disclaimer",
      "Artist": "Artist",
      "Facillity": "Facillity",
      "Event Prohibited": "Event Prohibited",
      "Explore": "Explore",
      "Gllery": "Gllery",
      "Video": "Video",
      "Tags": "Tags",
      "Ticket Details": "Ticket Details",
      "WHAT TICKET WOULD YOU LIKE?": "WHAT TICKET WOULD YOU LIKE?",
      "spots left": "spots left",
      "PURCHASE": "PURCHASE",
      "Book Now": "Book Now",
      "Go home": "Go home",
      "Event Details": "Event Details",
      "Confirm and pay": "Confirm and pay",
      "Apply Coupon": "Apply Coupon",
      "Apply": "Apply",
      "Remove": "Remove",
      "Pay from wallet": "Pay from wallet",
      "Your Balance": "Your Balance",
      "Available for Payment": "Available for Payment",
      "Price details": "Price details",
      "Price": "Price",
      "Fee": "Fee",
      "Coupon": "Coupon",
      "Total Payment": "Total Payment",
      "Confirm": "Confirm",
      "Available coupons": "Available coupons",
      "Expires": "Expires",
      "Sign in to Nabhiverse": "Sign in to Nabhiverse",
      "welcome back Please enter your details.": "welcome back Please enter your details.",
      "Phone Number": "Phone Number",
      "Forgot passowrd?": "Forgot passowrd?",
      "Reset it": "Reset it",
      "Sign In": "Sign In",
      "Don't have and account?": "Don't have and account?",
      "Sign Up": "Sign Up",
      "Can't Sign in?": "Can't Sign in?",
      "Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number": "Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number",
      "Continue": "Continue",
      "Return to Sign In": "Return to Sign In",
      "Awesome": "Awesome",
      "We have send the OTP to": "We have send the OTP to",
      "Your OTP": "Your OTP",
      "VERIFY OTP": "VERIFY OTP",
      "Create A New Password": "Create A New Password",
      "Passowrd": "Passowrd",
      'Confrim Password': 'Confrim Password',
      "Please Enter Details !!": "Please Enter Details !!",
      "Password must be at least 3 characters long!!": "Password must be at least 3 characters long!!",
      "Please enter number": "Please enter number",
      "OTP send successfully !!": "OTP send successfully !!",
      "OTP is invalid !!": "OTP is invalid !!",
      "Enter Password !!": "Enter Password !!",
      "Not Match Password !!": "Not Match Password !!",
      "Almost there!": "Almost there!",
      "You need to enter 6-digit code that we have send to your mobile number": "You need to enter 6-digit code that we have send to your mobile number",
      "By signing up, you agree to our": "By signing up, you agree to our",
      "and": "and",
      "Privacy Policy.": "Privacy Policy.",
      "Already have and account?": "Already have and account?",
      'Full Name': 'Full Name',
      'Email': 'Email',
      'Referral Code (Optional)': 'Referral Code (Optional)',
      "Please Enter a Valid Email !!": "Please Enter a Valid Email !!",
      "Password must be at least 3 characters long !!": "Password must be at least 3 characters long !!",
      "Payment in Process !!": "Payment in Process !!",
      "Select Payment Method !!": "Select Payment Method !!",
      "Select Payment Method": "Select Payment Method",
      "Loading...": "Loading...",
      "Select Cancel Reason !!": "Select Cancel Reason !!",
      "Active": "Active",
      "Completed": "Completed",
      "Go & Book your favorite Event !!": "Go & Book your favorite Event !!",
      "Select Reason": "Select Reason",
      "Please select the reason for cancellation": "Please select the reason for cancellation",
      "Cancel": "Cancel",
      "View E-Ticket": "View E-Ticket",
      'Financing fell through': 'Financing fell through',
      'Inspection issues': 'Inspection issues',
      'Change in financial situation': 'Change in financial situation',
      'Title issues': 'Title issues',
      'Seller changes their mind': 'Seller changes their mind',
      'Competing offer': 'Competing offer',
      'Personal Reasons': 'Personal Reasons',
      'Others': 'Others',
      'Enter Other Reason': 'Enter Other Reason',
      "Please Select User !!": "Please Select User !!",
      "Please Write Message !!": "Please Write Message !!",
      "Send": "Send",
      "Select User": "Select User",
      "Add Message...": "Add Message...",
      "Search...": "Search...",
      "Please select ticket !!": "Please select ticket !!",
      "Sorry, Favorite List Empty !!": "Sorry, Favorite List Empty !!",
      "Payment Faild !!": "Payment Faild !!",
      "Please Upload Photo !!": "Please Upload Photo !!",
      'Enter Name': 'Enter Name',
      'Enter Password': 'Enter Password',
      "Add Your Favorite Photo": "Add Your Favorite Photo",
      "Upload": "Upload",
      "Update": "Update",
      "Text copied to clipboard !!": "Text copied to clipboard !!",
      "E - Ticket": "E - Ticket",
      "Dates": "Dates",
      "Location": "Location",
      "Booking details": "Booking details",
      "Phone": "Phone",
      "Seats": "Seats",
      "Tax": "Tax",
      "Total": "Total",
      "Payment Method": "Payment Method",
      "Transaction ID": "Transaction ID",
      "Download Ticket": "Download Ticket",
      "Please Enter Amount !!": "Please Enter Amount !!",
      "Add Wallet": "Add Wallet",
      "Your Current Wallet Balance is": "Your Current Wallet Balance is",
      "Your Recent Transaction": "Your Recent Transaction",
      "Amount": "Amount",
      "Frequently asked questions": "Frequently asked questions",
      "Helps & FAQs": "Helps & FAQs",
      "Today": "Today",
      "Upcoming": "Upcoming",
      "Past": "Past",
      "Review": "Review",
      "Leave a Review": "Leave a Review",
      "How was your experience": "How was your experience",
      "Write Your Review": "Write Your Review",
      "Maybe Later": "Maybe Later",
      "Submit": "Submit",
      "Your reviewe here..": "Your reviewe here..",
      "No Any Notification !!": "No Any Notification !!",
      "You added": "You added",
      "items to": "items to",
      "favorites": "favorites",
      "bookings": "bookings",
      "Cancelled": "Cancelled",
      "Enable Smart Alerts": "Enable Smart Alerts",
      "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.": "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.",
      "Ticket Status": "Ticket Status",
    }
  },
  ar: {
    translation: {
      "Free Call": "مكالمة مجانية",
      "Online Support": "الدعم عبر الإنترنت",
      "Our Location": "موقعنا",
      "Language": "اللغة",
      "Notification": "الإشعارات",
      "Messages": "الرسائل",
      "Bookings": "الحجوزات",
      "Favorites": "المفضلة",
      "Wallet": "المحفظة",
      "Account": "الحساب",
      "Log out": "تسجيل الخروج",
      "Enable Location Services": "تفعيل خدمات الموقع",
      "To provide accurate services, please enable your location.": "لتقديم خدمات دقيقة، يرجى تفعيل موقعك.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "اسمح بالوصول إلى الموقع عند الطلب. إذا لم يظهر الطلب، فعّل ذلك في إعدادات المتصفح.",
      "Refresh the page after enabling.": "قم بتحديث الصفحة بعد التفعيل.",
      "Enable Now": "فعّل الآن",
      "Discover amazing event": "اكتشف فعاليات مذهلة",
      "Search here...": "ابحث هنا...",
      "Reviews": "التقييمات",
      "Browse by Category": "تصفح حسب الفئة",
      "Latest Event": "أحدث فعالية",
      "Just Dropped – Be the First to Book!": "وصلت للتو – كن أول من يحجز!",
      "Nearby Event": "فعالية قريبة",
      "Happening Around You – Don’t Miss Out!": "تحدث حولك – لا تفوتها!",
      "Monthly Event": "فعالية شهرية",
      "This Month’s Top Picks – Plan Your Fun!": "أفضل الاختيارات لهذا الشهر – خطط لمرحك!",
      "View Details": "عرض التفاصيل",
      "Upcoming Event": "فعالية قادمة",
      "Coming Soon – Save Your Spot Early!": "قريبًا – احجز مكانك مبكرًا!",
      "Instant Ticket Delivery": "توصيل التذاكر الفوري",
      "Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!": "احصل على تذاكر فعاليتك فورًا عبر البريد الإلكتروني أو الرسائل النصية – سريع ومجاني وبدون تعقيد!",
      "Easy Cancellations": "إلغاءات سهلة",
      "Change of plans? Cancel or reschedule your booking within 15 days with flexible options.": "تغيرت خططك؟ يمكنك إلغاء أو إعادة جدولة حجزك خلال 15 يومًا بخيارات مرنة.",
      "24/7 Customer Support": "دعم العملاء 24/7",
      "Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.": "هل لديك أسئلة؟ فريقنا متواجد 24 ساعة في اليوم، 7 أيام في الأسبوع لمساعدتك في كل خطوة.",
      "Secure Payment": "دفع آمن",
      "Book your tickets safely using multiple secure payment methods, including credit and debit cards.": "احجز تذاكرك بأمان باستخدام عدة طرق دفع آمنة، بما في ذلك بطاقات الائتمان والخصم.",
      "About Company": "عن الشركة",
      "We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.": "نجعل تخطيط الفعاليات بسيطًا وخاليًا من التوتر. سواء كنت تنظم حفلة موسيقية، مؤتمرًا، أو حفلة خاصة، منصتنا تربطك بأفضل الأماكن والخدمات لتحقيق رؤيتك.",
      "Help Information": "معلومات المساعدة",
      "Shipping Information": "معلومات الشحن",
      "Return & Refunds": "الإرجاع والاسترداد",
      "Payment Options": "خيارات الدفع",
      "FAQ": "الأسئلة الشائعة",
      "Terms of Service": "شروط الخدمة",
      "Account Information": "معلومات الحساب",
      "Login/Create Accoun": "تسجيل الدخول/إنشاء حساب",
      "Track Order": "تتبع الطلب",
      "Copyright © 2025 Nabhiverse, All Rights Reserved.": "حقوق النشر © 2025 ماجيك ميت، جميع الحقوق محفوظة.",
      "Home": "الرئيسية",
      "Event Not Available !!": "الفعالية غير متوفرة!!",
      "Ticket Price": "سعر التذكرة",
      "Organized By": "منظم بواسطة",
      "Attendees": "الحضور",
      "Chat": "الدردشة",
      "About Event": "عن الفعالية",
      "Disclaimer": "إخلاء المسؤولية",
      "Artist": "الفنان",
      "Facillity": "المرافق",
      "Event Prohibited": "الفعالية ممنوعة",
      "Explore": "استكشاف",
      "Gllery": "معرض الصور",
      "Video": "الفيديو",
      "Tags": "العلامات",
      "Ticket Details": "تفاصيل التذكرة",
      "WHAT TICKET WOULD YOU LIKE?": "أي تذكرة تود؟",
      "spots left": "أماكن متبقية",
      "PURCHASE": "شراء",
      "Book Now": "احجز الآن",
      "Go home": "اذهب للرئيسية",
      "Event Details": "تفاصيل الفعالية",
      "Confirm and pay": "تأكيد والدفع",
      "Apply Coupon": "تطبيق القسيمة",
      "Apply": "تطبيق",
      "Remove": "إزالة",
      "Pay from wallet": "الدفع من المحفظة",
      "Your Balance": "رصيدك",
      "Available for Payment": "متوفر للدفع",
      "Price details": "تفاصيل السعر",
      "Price": "السعر",
      "Fee": "الرسوم",
      "Coupon": "قسيمة",
      "Total Payment": "إجمالي الدفع",
      "Confirm": "تأكيد",
      "Available coupons": "القسائم المتوفرة",
      "Expires": "تنتهي الصلاحية",
      "Sign in to Nabhiverse": "تسجيل الدخول إلى ماجيك ميت",
      "welcome back Please enter your details.": "مرحبًا بعودتك، يرجى إدخال بياناتك.",
      "Phone Number": "رقم الهاتف",
      "Forgot passowrd?": "نسيت كلمة المرور؟",
      "Reset it": "إعادة تعيينها",
      "Sign In": "تسجيل الدخول",
      "Don't have and account?": "ليس لديك حساب؟",
      "Sign Up": "إنشاء حساب",
      "Can't Sign in?": "لا تستطيع تسجيل الدخول؟",
      "Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number": "أدخل رقم الجوال المرتبط بحسابك، وسترسل لك RideNow رمز التحقق (OTP) إلى رقم الجوال المسجل.",
      "Continue": "متابعة",
      "Return to Sign In": "العودة لتسجيل الدخول",
      "Awesome": "رائع",
      "We have send the OTP to": "لقد أرسلنا رمز التحقق إلى",
      "Your OTP": "رمز التحقق الخاص بك",
      "VERIFY OTP": "تحقق من الرمز",
      "Create A New Password": "إنشاء كلمة مرور جديدة",
      "Passowrd": "كلمة المرور",
      "Confrim Password": "تأكيد كلمة المرور",
      "Please Enter Details !!": "يرجى إدخال التفاصيل !!",
      "Password must be at least 3 characters long!!": "يجب أن تكون كلمة المرور 3 أحرف على الأقل!!",
      "Please enter number": "يرجى إدخال رقم",
      "OTP send successfully !!": "تم إرسال رمز التحقق بنجاح !!",
      "OTP is invalid !!": "رمز التحقق غير صحيح !!",
      "Enter Password !!": "أدخل كلمة المرور !!",
      "Not Match Password !!": "كلمة المرور غير متطابقة !!",
      "Almost there!": "اقتربنا!",
      "You need to enter 6-digit code that we have send to your mobile number": "يجب إدخال رمز مكون من 6 أرقام أرسلناه إلى رقم جوالك",
      "By signing up, you agree to our": "بالتسجيل، فإنك توافق على",
      "and": "و",
      "Privacy Policy.": "سياسة الخصوصية.",
      "Already have and account?": "هل لديك حساب بالفعل؟",
      "Full Name": "الاسم الكامل",
      "Email": "البريد الإلكتروني",
      "Referral Code (Optional)": "رمز الإحالة (اختياري)",
      "Please Enter a Valid Email !!": "يرجى إدخال بريد إلكتروني صالح !!",
      "Password must be at least 3 characters long !!": "يجب أن تكون كلمة المرور 3 أحرف على الأقل !!",
      "Payment in Process !!": "جاري معالجة الدفع !!",
      "Select Payment Method !!": "اختر طريقة الدفع !!",
      "Select Payment Method": "اختر طريقة الدفع",
      "Loading...": "جارٍ التحميل...",
      "Select Cancel Reason !!": "اختر سبب الإلغاء !!",
      "Active": "نشط",
      "Completed": "مكتمل",
      "Go & Book your favorite Event !!": "اذهب واحجز فعاليتك المفضلة !!",
      "Select Reason": "اختر السبب",
      "Please select the reason for cancellation": "يرجى اختيار سبب الإلغاء",
      "Cancel": "إلغاء",
      "View E-Ticket": "عرض التذكرة الإلكترونية",
      "Financing fell through": "فشل التمويل",
      "Inspection issues": "مشاكل في الفحص",
      "Change in financial situation": "تغير في الوضع المالي",
      "Title issues": "مشاكل في العنوان",
      "Seller changes their mind": "تغيير رأي البائع",
      "Competing offer": "عرض منافس",
      "Personal Reasons": "أسباب شخصية",
      "Others": "أخرى",
      "Enter Other Reason": "أدخل سببًا آخر",
      "Please Select User !!": "يرجى اختيار المستخدم !!",
      "Please Write Message !!": "يرجى كتابة رسالة !!",
      "Send": "إرسال",
      "Select User": "اختر المستخدم",
      "Add Message...": "أضف رسالة...",
      "Search...": "بحث...",
      "Please select ticket !!": "يرجى اختيار التذكرة !!",
      "Sorry, Favorite List Empty !!": "عذرًا، قائمة المفضلات فارغة !!",
      "Payment Faild !!": "فشل الدفع !!",
      "Please Upload Photo !!": "يرجى رفع صورة !!",
      "Enter Name": "أدخل الاسم",
      "Enter Password": "أدخل كلمة المرور",
      "Add Your Favorite Photo": "أضف صورتك المفضلة",
      "Upload": "رفع",
      "Update": "تحديث",
      "Text copied to clipboard !!": "تم نسخ النص إلى الحافظة !!",
      "E - Ticket": "التذكرة الإلكترونية",
      "Dates": "التواريخ",
      "Location": "الموقع",
      "Booking details": "تفاصيل الحجز",
      "Phone": "الهاتف",
      "Seats": "المقاعد",
      "Tax": "الضريبة",
      "Total": "الإجمالي",
      "Payment Method": "طريقة الدفع",
      "Transaction ID": "رقم المعاملة",
      "Download Ticket": "تحميل التذكرة",
      "Please Enter Amount !!": "يرجى إدخال المبلغ !!",
      "Add Wallet": "إضافة إلى المحفظة",
      "Your Current Wallet Balance is": "رصيد محفظتك الحالي هو",
      "Your Recent Transaction": "معاملاتك الأخيرة",
      "Amount": "المبلغ",
      "Frequently asked questions": "الأسئلة المتكررة",
      "Helps & FAQs": "المساعدة والأسئلة الشائعة",
      "Today": "اليوم",
      "Upcoming": "القادمة",
      "Past": "الماضية",
      "Review": "مراجعة",
      "Leave a Review": "اترك مراجعة",
      "How was your experience": "كيف كانت تجربتك",
      "Write Your Review": "اكتب مراجعتك",
      "Maybe Later": "ربما لاحقًا",
      "Submit": "إرسال",
      "Your reviewe here..": "مراجعتك هنا..",
      "No Any Notification !!": "لا توجد أي إشعارات !!",
      "You added": "لقد أضفت",
      "items to": "عناصر إلى",
      "favorites": "المفضلة",
      "bookings": "الحجوزات",
      "Cancelled": "أُلغيت",
      "Enable Smart Alerts": "تفعيل التنبيهات الذكية",
      "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.": "دعنا نُخطرك بالحجوزات القادمة، والتغييرات، والتحديثات الهامة مباشرةً عبر متصفحك.",
      "Ticket Status": "حالة التذكرة"
    }
  },
  hi: {
    translation: {
      "Free Call": "नि:शुल्क कॉल",
      "Online Support": "ऑनलाइन सहायता",
      "Our Location": "हमारा स्थान",
      "Language": "भाषा",
      "Notification": "सूचना",
      "Messages": "संदेश",
      "Bookings": "बुकिंग्स",
      "Favorites": "पसंदीदा",
      "Wallet": "वॉलेट",
      "Account": "खाता",
      "Log out": "लॉग आउट",
      "Enable Location Services": "स्थान सेवाएं सक्षम करें",
      "To provide accurate services, please enable your location.": "सटीक सेवाएं प्रदान करने के लिए, कृपया अपना स्थान सक्षम करें।",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "जब संकेत मिले तो स्थान एक्सेस की अनुमति दें। यदि संकेत नहीं मिलता है, तो इसे अपने ब्राउज़र सेटिंग्स में सक्षम करें।",
      "Refresh the page after enabling.": "सक्षम करने के बाद पृष्ठ को रीफ्रेश करें।",
      "Enable Now": "अभी सक्षम करें",
      "Discover amazing event": "शानदार इवेंट खोजें",
      "Search here...": "यहाँ खोजें...",
      "Reviews": "समीक्षाएं",
      "Browse by Category": "श्रेणी के अनुसार ब्राउज़ करें",
      "Latest Event": "नवीनतम इवेंट",
      "Just Dropped – Be the First to Book!": "अभी-अभी आया – सबसे पहले बुक करें!",
      "Nearby Event": "नज़दीकी इवेंट",
      "Happening Around You – Don’t Miss Out!": "आपके आस-पास हो रहा है – चूकिए मत!",
      "Monthly Event": "मासिक इवेंट",
      "This Month’s Top Picks – Plan Your Fun!": "इस महीने की टॉप पसंद – अपनी मस्ती की योजना बनाएं!",
      "View Details": "विवरण देखें",
      "Upcoming Event": "आगामी इवेंट",
      "Coming Soon – Save Your Spot Early!": "जल्द आ रहा है – अपनी जगह पहले से सुरक्षित करें!",
      "Instant Ticket Delivery": "तुरंत टिकट डिलीवरी",
      "Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!": "अपने इवेंट टिकट ईमेल या एसएमएस के जरिए तुरंत प्राप्त करें—तेज़, मुफ्त और बिना किसी झंझट के!",
      "Easy Cancellations": "आसान रद्दीकरण",
      "Change of plans? Cancel or reschedule your booking within 15 days with flexible options.": "योजना बदली? अपनी बुकिंग को 15 दिनों के भीतर रद्द या पुनर्निर्धारित करें, वह भी लचीले विकल्पों के साथ।",
      "24/7 Customer Support": "24/7 ग्राहक सहायता",
      "Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.": "कोई सवाल है? हमारी टीम सप्ताह के 7 दिन, 24 घंटे आपकी सहायता के लिए तैयार है।",
      "Secure Payment": "सुरक्षित भुगतान",
      "Book your tickets safely using multiple secure payment methods, including credit and debit cards.": "क्रेडिट और डेबिट कार्ड सहित कई सुरक्षित भुगतान विकल्पों से अपने टिकट सुरक्षित रूप से बुक करें।",
      "About Company": "कंपनी के बारे में",
      "We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.": "हम इवेंट की योजना बनाना सरल और तनावमुक्त बनाते हैं। चाहे आप एक कॉन्सर्ट, सम्मेलन या निजी पार्टी का आयोजन कर रहे हों, हमारा प्लेटफॉर्म आपको बेहतरीन स्थलों और सेवाओं से जोड़ता है ताकि आपके सपनों को साकार किया जा सके।",
      "Help Information": "सहायता जानकारी",
      "Shipping Information": "शिपिंग जानकारी",
      "Return & Refunds": "रिटर्न और रिफंड",
      "Payment Options": "भुगतान विकल्प",
      "FAQ": "सामान्य प्रश्न",
      "Terms of Service": "सेवा की शर्तें",
      "Account Information": "खाते की जानकारी",
      "Login/Create Accoun": "लॉगिन / खाता बनाएं",
      "Track Order": "ऑर्डर ट्रैक करें",
      "Copyright © 2025 Nabhiverse, All Rights Reserved.": "कॉपीराइट © 2025 Nabhiverse, सर्वाधिकार सुरक्षित।",
      "Home": "होम",
      "Event Not Available !!": "इवेंट उपलब्ध नहीं है !!",
      "Ticket Price": "टिकट कीमत",
      "Organized By": "आयोजित द्वारा",
      "Attendees": "उपस्थित लोग",
      "Chat": "चैट",
      "About Event": "इवेंट के बारे में",
      "Disclaimer": "अस्वीकरण",
      "Artist": "कलाकार",
      "Facillity": "सुविधा",
      "Event Prohibited": "इवेंट प्रतिबंधित है",
      "Explore": "एक्सप्लोर करें",
      "Gllery": "गैलरी",
      "Video": "वीडियो",
      "Tags": "टैग",
      "Ticket Details": "टिकट विवरण",
      "WHAT TICKET WOULD YOU LIKE?": "आपको कौन सा टिकट चाहिए?",
      "spots left": "स्पॉट बचे हैं",
      "PURCHASE": "खरीदें",
      "Book Now": "अब बुक करें",
      "Go home": "घर जाएं",
      "Event Details": "इवेंट विवरण",
      "Confirm and pay": "पुष्टि करें और भुगतान करें",
      "Apply Coupon": "कूपन लागू करें",
      "Apply": "लागू करें",
      "Remove": "हटाएं",
      "Pay from wallet": "वॉलेट से भुगतान करें",
      "Your Balance": "आपका बैलेंस",
      "Available for Payment": "भुगतान के लिए उपलब्ध",
      "Price details": "मूल्य विवरण",
      "Price": "मूल्य",
      "Fee": "शुल्क",
      "Coupon": "कूपन",
      "Total Payment": "कुल भुगतान",
      "Confirm": "पुष्टि करें",
      "Available coupons": "उपलब्ध कूपन",
      "Expires": "समाप्ति तिथि",
      "Sign in to Nabhiverse": "Nabhiverse में साइन इन करें",
      "welcome back Please enter your details.": "स्वागत है, कृपया अपनी जानकारी दर्ज करें।",
      "Phone Number": "फ़ोन नंबर",
      "Forgot passowrd?": "पासवर्ड भूल गए?",
      "Reset it": "रीसेट करें",
      "Sign In": "साइन इन करें",
      "Don't have and account?": "क्या आपका खाता नहीं है?",
      "Sign Up": "साइन अप करें",
      "Can't Sign in?": "साइन इन नहीं कर पा रहे हैं?",
      "Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number": "अपने खाते से जुड़े मोबाइल नंबर को दर्ज करें, और RideNow आपके रजिस्टर्ड मोबाइल नंबर पर OTP भेजेगा।",
      "Continue": "जारी रखें",
      "Return to Sign In": "साइन इन पर वापस जाएं",
      "Awesome": "शानदार",
      "We have send the OTP to": "हमने OTP भेज दिया है",
      "Your OTP": "आपका OTP",
      "VERIFY OTP": "OTP सत्यापित करें",
      "Create A New Password": "नया पासवर्ड बनाएं",
      "Passowrd": "पासवर्ड",
      "Confrim Password": "पासवर्ड की पुष्टि करें",
      "Please Enter Details !!": "कृपया विवरण दर्ज करें !!",
      "Password must be at least 3 characters long!!": "पासवर्ड कम से कम 3 अक्षरों का होना चाहिए !!",
      "Please enter number": "कृपया नंबर दर्ज करें",
      "OTP send successfully !!": "OTP सफलतापूर्वक भेजा गया !!",
      "OTP is invalid !!": "OTP अमान्य है !!",
      "Enter Password !!": "पासवर्ड दर्ज करें !!",
      "Not Match Password !!": "पासवर्ड मेल नहीं खाता !!",
      "Almost there!": "लगभग पूरा!",
      "You need to enter 6-digit code that we have send to your mobile number": "आपको 6-अंकों का कोड दर्ज करना होगा जो हमने आपके मोबाइल नंबर पर भेजा है।",
      "By signing up, you agree to our": "साइन अप करके, आप हमारी",
      "and": "और",
      "Privacy Policy.": "गोपनीयता नीति से सहमति देते हैं।",
      "Already have and account?": "क्या आपका पहले से खाता है?",
      "Full Name": "पूरा नाम",
      "Email": "ईमेल",
      "Referral Code (Optional)": "रेफरल कोड (वैकल्पिक)",
      "Please Enter a Valid Email !!": "कृपया एक मान्य ईमेल दर्ज करें !!",
      "Password must be at least 3 characters long !!": "पासवर्ड कम से कम 3 अक्षरों का होना चाहिए !!",
      "Payment in Process !!": "भुगतान प्रक्रिया में है !!",
      "Select Payment Method !!": "भुगतान विधि चुनें !!",
      "Select Payment Method": "भुगतान विधि चुनें",
      "Loading...": "लोड हो रहा है...",
      "Select Cancel Reason !!": "रद्द करने का कारण चुनें !!",
      "Active": "सक्रिय",
      "Completed": "पूर्ण",
      "Go & Book your favorite Event !!": "जाएँ और अपना पसंदीदा इवेंट बुक करें !!",
      "Select Reason": "कारण चुनें",
      "Please select the reason for cancellation": "कृपया रद्द करने का कारण चुनें",
      "Cancel": "रद्द करें",
      "View E-Ticket": "ई-टिकट देखें",
      "Financing fell through": "वित्तीय सहायता असफल रही",
      "Inspection issues": "निरीक्षण से संबंधित समस्याएँ",
      "Change in financial situation": "वित्तीय स्थिति में बदलाव",
      "Title issues": "स्वामित्व से जुड़ी समस्याएँ",
      "Seller changes their mind": "विक्रेता ने अपना मन बदल लिया",
      "Competing offer": "प्रतिस्पर्धी प्रस्ताव",
      "Personal Reasons": "व्यक्तिगत कारण",
      "Others": "अन्य",
      "Enter Other Reason": "अन्य कारण दर्ज करें",
      "Please Select User !!": "कृपया उपयोगकर्ता चुनें !!",
      "Please Write Message !!": "कृपया संदेश लिखें !!",
      "Send": "भेजें",
      "Select User": "उपयोगकर्ता चुनें",
      "Add Message...": "संदेश जोड़ें...",
      "Search...": "खोजें...",
      "Please select ticket !!": "कृपया टिकट चुनें !!",
      "Sorry, Favorite List Empty !!": "क्षमा करें, पसंदीदा सूची खाली है !!",
      "Payment Faild !!": "भुगतान विफल हुआ !!",
      "Please Upload Photo !!": "कृपया फोटो अपलोड करें !!",
      "Enter Name": "नाम दर्ज करें",
      "Enter Password": "पासवर्ड दर्ज करें",
      "Add Your Favorite Photo": "अपनी पसंदीदा फोटो जोड़ें",
      "Upload": "अपलोड करें",
      "Update": "अपडेट करें",
      "Text copied to clipboard !!": "पाठ क्लिपबोर्ड में कॉपी किया गया !!",
      "E - Ticket": "ई-टिकट",
      "Dates": "तिथियाँ",
      "Location": "स्थान",
      "Booking details": "बुकिंग विवरण",
      "Phone": "फ़ोन",
      "Seats": "सीटें",
      "Tax": "कर",
      "Total": "कुल",
      "Payment Method": "भुगतान विधि",
      "Transaction ID": "लेनदेन आईडी",
      "Download Ticket": "टिकट डाउनलोड करें",
      "Please Enter Amount !!": "कृपया राशि दर्ज करें !!",
      "Add Wallet": "वॉलेट जोड़ें",
      "Your Current Wallet Balance is": "आपका वर्तमान वॉलेट बैलेंस है",
      "Your Recent Transaction": "आपका हालिया लेनदेन",
      "Amount": "राशि",
      "Frequently asked questions": "अक्सर पूछे जाने वाले प्रश्न",
      "Helps & FAQs": "सहायता और अक्सर पूछे जाने वाले प्रश्न",
      "Today": "आज",
      "Upcoming": "आगामी",
      "Past": "अतीत",
      "Review": "समीक्षा",
      "Leave a Review": "समीक्षा छोड़ें",
      "How was your experience": "आपका अनुभव कैसा था",
      "Write Your Review": "अपनी समीक्षा लिखें",
      "Maybe Later": "शायद बाद में",
      "Submit": "जमा करें",
      "Your reviewe here..": "आपकी समीक्षा यहां..",
      "No Any Notification !!": "कोई सूचना नहीं !!",
      "You added": "आपने जोड़ा",
      "items to": "आइटम को",
      "favorites": "पसंदीदा",
      "bookings": "बुकिंग्स",
      "Cancelled": "रद्द किया गया",
      "Enable Smart Alerts": "स्मार्ट अलर्ट सक्षम करें",
      "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.": "आने वाली बुकिंग्स, बदलावों और महत्वपूर्ण अपडेट्स की जानकारी आपको सीधे ब्राउज़र के ज़रिए दें।",
      "Ticket Status": "टिकट की स्थिति"
    }
  },
  sp: {
    translation: {
      "Free Call": "Llamada Gratis",
      "Online Support": "Soporte en Línea",
      "Our Location": "Nuestra Ubicación",
      "Language": "Idioma",
      "Notification": "Notificación",
      "Messages": "Mensajes",
      "Bookings": "Reservas",
      "Favorites": "Favoritos",
      "Wallet": "Billetera",
      "Account": "Cuenta",
      "Log out": "Cerrar sesión",
      "Enable Location Services": "Habilitar Servicios de Ubicación",
      "To provide accurate services, please enable your location.": "Para ofrecer servicios precisos, por favor habilite su ubicación.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Permita el acceso a la ubicación cuando se le solicite. Si no se le solicita, actívelo en la configuración de su navegador.",
      "Refresh the page after enabling.": "Actualice la página después de habilitarlo.",
      "Enable Now": "Habilitar ahora",
      "Discover amazing event": "Descubre eventos increíbles",
      "Search here...": "Buscar aquí...",
      "Reviews": "Reseñas",
      "Browse by Category": "Explorar por Categoría",
      "Latest Event": "Último Evento",
      "Just Dropped – Be the First to Book!": "Recién Lanzado – ¡Sé el primero en reservar!",
      "Nearby Event": "Evento Cercano",
      "Happening Around You – Don’t Miss Out!": "Sucediendo cerca de ti – ¡No te lo pierdas!",
      "Monthly Event": "Evento Mensual",
      "This Month’s Top Picks – Plan Your Fun!": "Las mejores opciones del mes – ¡Planifica tu diversión!",
      "View Details": "Ver Detalles",
      "Upcoming Event": "Evento Próximo",
      "Coming Soon – Save Your Spot Early!": "Próximamente – ¡Reserva tu lugar temprano!",
      "Instant Ticket Delivery": "Entrega Instantánea de Entradas",
      "Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!": "Recibe tus entradas para el evento instantáneamente por correo electrónico o SMS—rápido, gratis y sin complicaciones.",
      "Easy Cancellations": "Cancelaciones Fáciles",
      "Change of plans? Cancel or reschedule your booking within 15 days with flexible options.": "¿Cambio de planes? Cancela o reprograma tu reserva dentro de 15 días con opciones flexibles.",
      "24/7 Customer Support": "Soporte al Cliente 24/7",
      "Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.": "¿Preguntas? Nuestro equipo está disponible las 24 horas, los 7 días de la semana para ayudarte en cada paso.",
      "Secure Payment": "Pago Seguro",
      "Book your tickets safely using multiple secure payment methods, including credit and debit cards.": "Reserva tus entradas de forma segura usando múltiples métodos de pago seguros, incluyendo tarjetas de crédito y débito.",
      "About Company": "Acerca de la Compañía",
      "We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.": "Hacemos que la planificación de eventos sea sencilla y sin estrés. Ya sea que organices un concierto, conferencia o fiesta privada, nuestra plataforma te conecta con los mejores lugares y servicios para hacer realidad tu visión.",
      "Help Information": "Información de Ayuda",
      "Shipping Information": "Información de Envío",
      "Return & Refunds": "Devoluciones y Reembolsos",
      "Payment Options": "Opciones de Pago",
      "FAQ": "Preguntas Frecuentes",
      "Terms of Service": "Términos de Servicio",
      "Account Information": "Información de la Cuenta",
      "Login/Create Accoun": "Iniciar Sesión/Crear Cuenta",
      "Track Order": "Rastrear Pedido",
      "Copyright © 2025 Nabhiverse, All Rights Reserved.": "Copyright © 2025 Nabhiverse, Todos los Derechos Reservados.",
      "Home": "Inicio",
      "Event Not Available !!": "¡Evento No Disponible!",
      "Ticket Price": "Precio del Ticket",
      "Organized By": "Organizado Por",
      "Attendees": "Asistentes",
      "Chat": "Chat",
      "About Event": "Acerca del Evento",
      "Disclaimer": "Aviso Legal",
      "Artist": "Artista",
      "Facillity": "Instalaciones",
      "Event Prohibited": "Evento Prohibido",
      "Explore": "Explorar",
      "Gllery": "Galería",
      "Video": "Video",
      "Tags": "Etiquetas",
      "Ticket Details": "Detalles del Ticket",
      "WHAT TICKET WOULD YOU LIKE?": "¿QUÉ TICKET DESEAS?",
      "spots left": "lugares disponibles",
      "PURCHASE": "COMPRAR",
      "Book Now": "Reservar Ahora",
      "Go home": "Ir a Inicio",
      "Event Details": "Detalles del Evento",
      "Confirm and pay": "Confirmar y pagar",
      "Apply Coupon": "Aplicar Cupón",
      "Apply": "Aplicar",
      "Remove": "Eliminar",
      "Pay from wallet": "Pagar desde billetera",
      "Your Balance": "Tu Saldo",
      "Available for Payment": "Disponible para Pago",
      "Price details": "Detalles del Precio",
      "Price": "Precio",
      "Fee": "Tarifa",
      "Coupon": "Cupón",
      "Total Payment": "Pago Total",
      "Confirm": "Confirmar",
      "Available coupons": "Cupones disponibles",
      "Expires": "Expira",
      "Sign in to Nabhiverse": "Iniciar sesión en Nabhiverse",
      "welcome back Please enter your details.": "Bienvenido de nuevo, por favor ingresa tus datos.",
      "Phone Number": "Número de Teléfono",
      "Forgot passowrd?": "¿Olvidaste la contraseña?",
      "Reset it": "Restablecer",
      "Sign In": "Iniciar Sesión",
      "Don't have and account?": "¿No tienes una cuenta?",
      "Sign Up": "Registrarse",
      "Can't Sign in?": "¿No puedes iniciar sesión?",
      "Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number": "Ingresa el número de móvil asociado a tu cuenta, y RideNow te enviará un OTP a tu número registrado",
      "Continue": "Continuar",
      "Return to Sign In": "Volver a Iniciar Sesión",
      "Awesome": "Genial",
      "We have send the OTP to": "Hemos enviado el OTP a",
      "Your OTP": "Tu OTP",
      "VERIFY OTP": "VERIFICAR OTP",
      "Create A New Password": "Crear Una Nueva Contraseña",
      "Passowrd": "Contraseña",
      "Confrim Password": "Confirmar Contraseña",
      "Please Enter Details !!": "¡Por favor ingresa los datos!",
      "Password must be at least 3 characters long!!": "¡La contraseña debe tener al menos 3 caracteres!",
      "Please enter number": "Por favor ingresa un número",
      "OTP send successfully !!": "¡OTP enviado exitosamente!",
      "OTP is invalid !!": "¡OTP inválido!",
      "Enter Password !!": "¡Ingresa la contraseña!",
      "Not Match Password !!": "¡La contraseña no coincide!",
      "Almost there!": "¡Casi listo!",
      "You need to enter 6-digit code that we have send to your mobile number": "Debes ingresar el código de 6 dígitos que enviamos a tu número móvil",
      "By signing up, you agree to our": "Al registrarte, aceptas nuestra",
      "and": "y",
      "Privacy Policy.": "Política de Privacidad.",
      "Already have and account?": "¿Ya tienes una cuenta?",
      "Full Name": "Nombre Completo",
      "Email": "Correo Electrónico",
      "Referral Code (Optional)": "Código de Referencia (Opcional)",
      "Please Enter a Valid Email !!": "¡Por favor ingresa un correo válido!",
      "Password must be at least 3 characters long !!": "¡La contraseña debe tener al menos 3 caracteres!",
      "Payment in Process !!": "¡Pago en proceso!",
      "Select Payment Method !!": "¡Selecciona un método de pago!",
      "Select Payment Method": "Seleccionar Método de Pago",
      "Loading...": "Cargando...",
      "Select Cancel Reason !!": "¡Selecciona un motivo de cancelación!",
      "Active": "Activo",
      "Completed": "Completado",
      "Go & Book your favorite Event !!": "¡Ve y reserva tu evento favorito!",
      "Select Reason": "Seleccionar Motivo",
      "Please select the reason for cancellation": "Por favor selecciona el motivo de cancelación",
      "Cancel": "Cancelar",
      "View E-Ticket": "Ver E-Ticket",
      "Financing fell through": "El financiamiento falló",
      "Inspection issues": "Problemas de inspección",
      "Change in financial situation": "Cambio en la situación financiera",
      "Title issues": "Problemas de título",
      "Seller changes their mind": "El vendedor cambió de opinión",
      "Competing offer": "Oferta competidora",
      "Personal Reasons": "Razones personales",
      "Others": "Otros",
      "Enter Other Reason": "Ingresa otro motivo",
      "Please Select User !!": "¡Por favor selecciona un usuario!",
      "Please Write Message !!": "¡Por favor escribe un mensaje!",
      "Send": "Enviar",
      "Select User": "Seleccionar Usuario",
      "Add Message...": "Agregar Mensaje...",
      "Search...": "Buscar...",
      "Please select ticket !!": "¡Por favor selecciona un ticket!",
      "Sorry, Favorite List Empty !!": "Lo sentimos, la lista de favoritos está vacía",
      "Payment Faild !!": "¡Pago fallido!",
      "Please Upload Photo !!": "¡Por favor sube una foto!",
      "Enter Name": "Ingresa el nombre",
      "Enter Password": "Ingresa la contraseña",
      "Add Your Favorite Photo": "Agrega tu foto favorita",
      "Upload": "Subir",
      "Update": "Actualizar",
      "Text copied to clipboard !!": "¡Texto copiado al portapapeles!",
      "E - Ticket": "E - Ticket",
      "Dates": "Fechas",
      "Location": "Ubicación",
      "Booking details": "Detalles de la reserva",
      "Phone": "Teléfono",
      "Seats": "Asientos",
      "Tax": "Impuesto",
      "Total": "Total",
      "Payment Method": "Método de Pago",
      "Transaction ID": "ID de Transacción",
      "Download Ticket": "Descargar Ticket",
      "Please Enter Amount !!": "¡Por favor ingresa la cantidad!",
      "Add Wallet": "Agregar a Billetera",
      "Your Current Wallet Balance is": "Tu saldo actual en billetera es",
      "Your Recent Transaction": "Tu transacción reciente",
      "Amount": "Cantidad",
      "Frequently asked questions": "Preguntas frecuentes",
      "Helps & FAQs": "Ayuda y FAQs",
      "Today": "Hoy",
      "Upcoming": "Próximos",
      "Past": "Pasados",
      "Review": "Reseña",
      "Leave a Review": "Deja una reseña",
      "How was your experience": "¿Cómo fue tu experiencia?",
      "Write Your Review": "Escribe tu reseña",
      "Maybe Later": "Tal vez después",
      "Submit": "Enviar",
      "Your reviewe here..": "Tu reseña aquí..",
      "No Any Notification !!": "¡No hay notificaciones!",
      "You added": "Has añadido",
      "items to": "elementos a",
      "favorites": "favoritos",
      "bookings": "reservas",
      "Cancelled": "Cancelado",
      "Enable Smart Alerts": "Activar alertas inteligentes",
      "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.": "Permítenos notificarte sobre próximas reservas, cambios y actualizaciones importantes directamente a través de tu navegador.",
      "Ticket Status": "Estado del ticket"
    }
  },
  fr: {
    translation: {
      "Free Call": "Appel Gratuit",
      "Online Support": "Support en Ligne",
      "Our Location": "Notre Emplacement",
      "Language": "Langue",
      "Notification": "Notification",
      "Messages": "Messages",
      "Bookings": "Réservations",
      "Favorites": "Favoris",
      "Wallet": "Portefeuille",
      "Account": "Compte",
      "Log out": "Se déconnecter",
      "Enable Location Services": "Activer les Services de Localisation",
      "To provide accurate services, please enable your location.": "Pour fournir des services précis, veuillez activer votre localisation.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Autorisez l'accès à la localisation lorsque demandé. Sinon, activez-le dans les paramètres de votre navigateur.",
      "Refresh the page after enabling.": "Actualisez la page après activation.",
      "Enable Now": "Activer Maintenant",
      "Discover amazing event": "Découvrez un événement incroyable",
      "Search here...": "Recherchez ici...",
      "Reviews": "Avis",
      "Browse by Category": "Parcourir par Catégorie",
      "Latest Event": "Dernier Événement",
      "Just Dropped – Be the First to Book!": "Nouveau – Soyez le premier à réserver !",
      "Nearby Event": "Événement Proche",
      "Happening Around You – Don’t Miss Out!": "Se déroule près de vous – Ne ratez pas ça !",
      "Monthly Event": "Événement Mensuel",
      "This Month’s Top Picks – Plan Your Fun!": "Les meilleurs choix du mois – Planifiez votre plaisir !",
      "View Details": "Voir les Détails",
      "Upcoming Event": "Événement à Venir",
      "Coming Soon – Save Your Spot Early!": "Bientôt disponible – Réservez votre place tôt !",
      "Instant Ticket Delivery": "Livraison Instantanée des Billets",
      "Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!": "Recevez vos billets d'événement instantanément par email ou SMS — rapide, gratuit et sans tracas !",
      "Easy Cancellations": "Annulations Faciles",
      "Change of plans? Cancel or reschedule your booking within 15 days with flexible options.": "Changement de plans ? Annulez ou modifiez votre réservation dans les 15 jours avec des options flexibles.",
      "24/7 Customer Support": "Support Client 24h/24 et 7j/7",
      "Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.": "Des questions ? Notre équipe est là 24h/24 et 7j/7 pour vous aider à chaque étape.",
      "Secure Payment": "Paiement Sécurisé",
      "Book your tickets safely using multiple secure payment methods, including credit and debit cards.": "Réservez vos billets en toute sécurité grâce à plusieurs méthodes de paiement sécurisées, y compris les cartes de crédit et de débit.",
      "About Company": "À propos de l'entreprise",
      "We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.": "Nous rendons la planification d'événements simple et sans stress. Que vous organisiez un concert, une conférence ou une fête privée, notre plateforme vous connecte aux meilleurs lieux et services pour réaliser votre projet.",
      "Help Information": "Informations d'Aide",
      "Shipping Information": "Informations sur la Livraison",
      "Return & Refunds": "Retours & Remboursements",
      "Payment Options": "Options de Paiement",
      "FAQ": "FAQ",
      "Terms of Service": "Conditions d'Utilisation",
      "Account Information": "Informations du Compte",
      "Login/Create Accoun": "Connexion/Création de Compte",
      "Track Order": "Suivi de Commande",
      "Copyright © 2025 Nabhiverse, All Rights Reserved.": "Copyright © 2025 Nabhiverse, Tous Droits Réservés.",
      "Home": "Accueil",
      "Event Not Available !!": "Événement Non Disponible !!",
      "Ticket Price": "Prix du Billet",
      "Organized By": "Organisé Par",
      "Attendees": "Participants",
      "Chat": "Discussion",
      "About Event": "À propos de l'Événement",
      "Disclaimer": "Avertissement",
      "Artist": "Artiste",
      "Facillity": "Équipements",
      "Event Prohibited": "Événement Interdit",
      "Explore": "Explorer",
      "Gllery": "Galerie",
      "Video": "Vidéo",
      "Tags": "Tags",
      "Ticket Details": "Détails du Billet",
      "WHAT TICKET WOULD YOU LIKE?": "QUEL BILLET SOUHAITEZ-VOUS ?",
      "spots left": "places restantes",
      "PURCHASE": "ACHETER",
      "Book Now": "Réserver Maintenant",
      "Go home": "Aller à l'accueil",
      "Event Details": "Détails de l'Événement",
      "Confirm and pay": "Confirmer et payer",
      "Apply Coupon": "Appliquer le Coupon",
      "Apply": "Appliquer",
      "Remove": "Supprimer",
      "Pay from wallet": "Payer avec le portefeuille",
      "Your Balance": "Votre Solde",
      "Available for Payment": "Disponible pour le Paiement",
      "Price details": "Détails du Prix",
      "Price": "Prix",
      "Fee": "Frais",
      "Coupon": "Coupon",
      "Total Payment": "Paiement Total",
      "Confirm": "Confirmer",
      "Available coupons": "Coupons Disponibles",
      "Expires": "Expire",
      "Sign in to Nabhiverse": "Connectez-vous à Nabhiverse",
      "welcome back Please enter your details.": "Bienvenue, veuillez entrer vos informations.",
      "Phone Number": "Numéro de Téléphone",
      "Forgot passowrd?": "Mot de passe oublié ?",
      "Reset it": "Réinitialisez-le",
      "Sign In": "Se Connecter",
      "Don't have and account?": "Vous n'avez pas de compte ?",
      "Sign Up": "S'inscrire",
      "Can't Sign in?": "Impossible de se connecter ?",
      "Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number": "Entrez le numéro de mobile associé à votre compte, et RideNow vous enverra un code OTP sur votre numéro enregistré",
      "Continue": "Continuer",
      "Return to Sign In": "Retour à la connexion",
      "Awesome": "Super",
      "We have send the OTP to": "Nous avons envoyé le code OTP à",
      "Your OTP": "Votre OTP",
      "VERIFY OTP": "VÉRIFIER OTP",
      "Create A New Password": "Créer un nouveau mot de passe",
      "Passowrd": "Mot de passe",
      "Confrim Password": "Confirmer le mot de passe",
      "Please Enter Details !!": "Veuillez entrer les détails !!",
      "Password must be at least 3 characters long!!": "Le mot de passe doit contenir au moins 3 caractères !!",
      "Please enter number": "Veuillez entrer un numéro",
      "OTP send successfully !!": "OTP envoyé avec succès !!",
      "OTP is invalid !!": "OTP invalide !!",
      "Enter Password !!": "Entrez le mot de passe !!",
      "Not Match Password !!": "Les mots de passe ne correspondent pas !!",
      "Almost there!": "Presque terminé !",
      "You need to enter 6-digit code that we have send to your mobile number": "Vous devez entrer le code à 6 chiffres que nous avons envoyé à votre numéro de mobile",
      "By signing up, you agree to our": "En vous inscrivant, vous acceptez nos",
      "and": "et",
      "Privacy Policy.": "Politique de confidentialité.",
      "Already have and account?": "Vous avez déjà un compte ?",
      "Full Name": "Nom complet",
      "Email": "Email",
      "Referral Code (Optional)": "Code de parrainage (optionnel)",
      "Please Enter a Valid Email !!": "Veuillez entrer un email valide !!",
      "Password must be at least 3 characters long !!": "Le mot de passe doit contenir au moins 3 caractères !!",
      "Payment in Process !!": "Paiement en cours !!",
      "Select Payment Method !!": "Sélectionnez une méthode de paiement !!",
      "Select Payment Method": "Sélectionner la méthode de paiement",
      "Loading...": "Chargement...",
      "Select Cancel Reason !!": "Sélectionnez la raison de l'annulation !!",
      "Active": "Actif",
      "Completed": "Terminé",
      "Go & Book your favorite Event !!": "Allez et réservez votre événement préféré !!",
      "Select Reason": "Sélectionner une raison",
      "Please select the reason for cancellation": "Veuillez sélectionner la raison de l'annulation",
      "Cancel": "Annuler",
      "View E-Ticket": "Voir le billet électronique",
      "Financing fell through": "Financement échoué",
      "Inspection issues": "Problèmes d'inspection",
      "Change in financial situation": "Changement de situation financière",
      "Title issues": "Problèmes de titre",
      "Seller changes their mind": "Le vendeur a changé d'avis",
      "Competing offer": "Offre concurrente",
      "Personal Reasons": "Raisons personnelles",
      "Others": "Autres",
      "Enter Other Reason": "Entrez une autre raison",
      "Please Select User !!": "Veuillez sélectionner un utilisateur !!",
      "Please Write Message !!": "Veuillez écrire un message !!",
      "Send": "Envoyer",
      "Select User": "Sélectionner un utilisateur",
      "Add Message...": "Ajouter un message...",
      "Search...": "Rechercher...",
      "Please select ticket !!": "Veuillez sélectionner un billet !!",
      "Sorry, Favorite List Empty !!": "Désolé, la liste des favoris est vide !!",
      "Payment Faild !!": "Paiement échoué !!",
      "Please Upload Photo !!": "Veuillez télécharger une photo !!",
      "Enter Name": "Entrez le nom",
      "Enter Password": "Entrez le mot de passe",
      "Add Your Favorite Photo": "Ajoutez votre photo préférée",
      "Upload": "Télécharger",
      "Update": "Mettre à jour",
      "Text copied to clipboard !!": "Texte copié dans le presse-papiers !!",
      "E - Ticket": "Billet électronique",
      "Dates": "Dates",
      "Location": "Lieu",
      "Booking details": "Détails de la réservation",
      "Phone": "Téléphone",
      "Seats": "Places",
      "Tax": "Taxe",
      "Total": "Total",
      "Payment Method": "Méthode de paiement",
      "Transaction ID": "ID de transaction",
      "Download Ticket": "Télécharger le billet",
      "Please Enter Amount !!": "Veuillez entrer un montant !!",
      "Add Wallet": "Ajouter au portefeuille",
      "Your Current Wallet Balance is": "Votre solde actuel du portefeuille est",
      "Your Recent Transaction": "Vos transactions récentes",
      "Amount": "Montant",
      "Frequently asked questions": "Questions fréquentes",
      "Helps & FAQs": "Aide & FAQ",
      "Today": "Aujourd'hui",
      "Upcoming": "À venir",
      "Past": "Passé",
      "Review": "Avis",
      "Leave a Review": "Laisser un avis",
      "How was your experience": "Comment était votre expérience",
      "Write Your Review": "Écrivez votre avis",
      "Maybe Later": "Peut-être plus tard",
      "Submit": "Soumettre",
      "Your reviewe here..": "Votre avis ici..",
      "No Any Notification !!": "Aucune notification !!",
      "You added": "Vous avez ajouté",
      "items to": "éléments à",
      "favorites": "favoris",
      "bookings": "réservations",
      "Cancelled": "Annulé",
      "Enable Smart Alerts": "Activer les alertes intelligentes",
      "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.": "Laissez-nous vous notifier des réservations à venir, des changements et des mises à jour importantes directement via votre navigateur.",
      "Ticket Status": "Statut du billet"
    }
  },
  ge: {
    translation: {
      "Free Call": "Kostenloser Anruf",
      "Online Support": "Online-Support",
      "Our Location": "Unser Standort",
      "Language": "Sprache",
      "Notification": "Benachrichtigung",
      "Messages": "Nachrichten",
      "Bookings": "Buchungen",
      "Favorites": "Favoriten",
      "Wallet": "Brieftasche",
      "Account": "Konto",
      "Log out": "Abmelden",
      "Enable Location Services": "Standortdienste aktivieren",
      "To provide accurate services, please enable your location.": "Um genaue Dienste anzubieten, aktivieren Sie bitte Ihren Standort.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Erlauben Sie den Standortzugriff, wenn Sie dazu aufgefordert werden. Falls nicht, aktivieren Sie ihn in den Browsereinstellungen.",
      "Refresh the page after enabling.": "Seite nach der Aktivierung aktualisieren.",
      "Enable Now": "Jetzt aktivieren",
      "Discover amazing event": "Entdecken Sie erstaunliche Events",
      "Search here...": "Hier suchen...",
      "Reviews": "Bewertungen",
      "Browse by Category": "Nach Kategorie durchsuchen",
      "Latest Event": "Neueste Veranstaltung",
      "Just Dropped – Be the First to Book!": "Gerade veröffentlicht – Sei der Erste, der bucht!",
      "Nearby Event": "Veranstaltung in der Nähe",
      "Happening Around You – Don’t Miss Out!": "Veranstaltungen in Ihrer Nähe – Nicht verpassen!",
      "Monthly Event": "Monatliche Veranstaltung",
      "This Month’s Top Picks – Plan Your Fun!": "Top-Auswahl dieses Monats – Plane deinen Spaß!",
      "View Details": "Details ansehen",
      "Upcoming Event": "Kommende Veranstaltung",
      "Coming Soon – Save Your Spot Early!": "Demnächst – Sichere dir frühzeitig deinen Platz!",
      "Instant Ticket Delivery": "Sofortige Ticketlieferung",
      "Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!": "Erhalte deine Tickets sofort per E-Mail oder SMS – schnell, kostenlos und unkompliziert!",
      "Easy Cancellations": "Einfache Stornierungen",
      "Change of plans? Cancel or reschedule your booking within 15 days with flexible options.": "Planänderung? Stornieren oder verschieben Sie Ihre Buchung innerhalb von 15 Tagen mit flexiblen Optionen.",
      "24/7 Customer Support": "24/7 Kundensupport",
      "Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.": "Fragen? Unser Team ist rund um die Uhr für Sie da.",
      "Secure Payment": "Sichere Zahlung",
      "Book your tickets safely using multiple secure payment methods, including credit and debit cards.": "Buchen Sie Ihre Tickets sicher mit verschiedenen sicheren Zahlungsmethoden, einschließlich Kredit- und Debitkarten.",
      "About Company": "Über das Unternehmen",
      "We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.": "Wir machen Eventplanung einfach und stressfrei. Egal ob Konzert, Konferenz oder private Party – unsere Plattform verbindet Sie mit den besten Locations und Services, um Ihre Vision zu verwirklichen.",
      "Help Information": "Hilfsinformationen",
      "Shipping Information": "Versandinformationen",
      "Return & Refunds": "Rückgabe & Rückerstattung",
      "Payment Options": "Zahlungsoptionen",
      "FAQ": "FAQ",
      "Terms of Service": "Nutzungsbedingungen",
      "Account Information": "Kontoinformationen",
      "Login/Create Accoun": "Anmelden/Account erstellen",
      "Track Order": "Bestellung verfolgen",
      "Copyright © 2025 Nabhiverse, All Rights Reserved.": "Copyright © 2025 Nabhiverse, Alle Rechte vorbehalten.",
      "Home": "Startseite",
      "Event Not Available !!": "Veranstaltung nicht verfügbar !!",
      "Ticket Price": "Ticketpreis",
      "Organized By": "Organisiert von",
      "Attendees": "Teilnehmer",
      "Chat": "Chat",
      "About Event": "Über die Veranstaltung",
      "Disclaimer": "Haftungsausschluss",
      "Artist": "Künstler",
      "Facillity": "Einrichtung",
      "Event Prohibited": "Veranstaltung verboten",
      "Explore": "Entdecken",
      "Gllery": "Galerie",
      "Video": "Video",
      "Tags": "Tags",
      "Ticket Details": "Ticketdetails",
      "WHAT TICKET WOULD YOU LIKE?": "WELCHES TICKET MÖCHTEN SIE?",
      "spots left": "verbleibende Plätze",
      "PURCHASE": "KAUFEN",
      "Book Now": "Jetzt buchen",
      "Go home": "Zur Startseite",
      "Event Details": "Veranstaltungsdetails",
      "Confirm and pay": "Bestätigen und bezahlen",
      "Apply Coupon": "Gutschein anwenden",
      "Apply": "Anwenden",
      "Remove": "Entfernen",
      "Pay from wallet": "Vom Wallet bezahlen",
      "Your Balance": "Ihr Guthaben",
      "Available for Payment": "Verfügbar zur Zahlung",
      "Price details": "Preisinformationen",
      "Price": "Preis",
      "Fee": "Gebühr",
      "Coupon": "Gutschein",
      "Total Payment": "Gesamtzahlung",
      "Confirm": "Bestätigen",
      "Available coupons": "Verfügbare Gutscheine",
      "Expires": "Läuft ab",
      "Sign in to Nabhiverse": "Bei Nabhiverse anmelden",
      "welcome back Please enter your details.": "Willkommen zurück, bitte geben Sie Ihre Daten ein.",
      "Phone Number": "Telefonnummer",
      "Forgot passowrd?": "Passwort vergessen?",
      "Reset it": "Zurücksetzen",
      "Sign In": "Anmelden",
      "Don't have and account?": "Noch keinen Account?",
      "Sign Up": "Registrieren",
      "Can't Sign in?": "Kannst du dich nicht anmelden?",
      "Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number": "Gib die mit deinem Konto verknüpfte Handynummer ein, und RideNow sendet dir einen OTP an deine registrierte Nummer",
      "Continue": "Weiter",
      "Return to Sign In": "Zurück zur Anmeldung",
      "Awesome": "Super",
      "We have send the OTP to": "Wir haben den OTP gesendet an",
      "Your OTP": "Dein OTP",
      "VERIFY OTP": "OTP BESTÄTIGEN",
      "Create A New Password": "Neues Passwort erstellen",
      "Password": "Passwort",
      "Confirm Password": "Passwort bestätigen",
      "Please Enter Details !!": "Bitte Daten eingeben!!",
      "Password must be at least 3 characters long!!": "Das Passwort muss mindestens 3 Zeichen lang sein!!",
      "Please enter number": "Bitte Nummer eingeben",
      "OTP send successfully !!": "OTP erfolgreich gesendet!!",
      "OTP is invalid !!": "Ungültiger OTP!!",
      "Enter Password !!": "Passwort eingeben!!",
      "Not Match Password !!": "Passwörter stimmen nicht überein!!",
      "Almost there!": "Fast geschafft!",
      "You need to enter 6-digit code that we have send to your mobile number": "Du musst den 6-stelligen Code eingeben, den wir an deine Handynummer gesendet haben",
      "By signing up, you agree to our": "Mit der Registrierung stimmst du unseren",
      "and": "und",
      "Privacy Policy.": "Datenschutzrichtlinien zu.",
      "Already have and account?": "Du hast bereits ein Konto?",
      "Full Name": "Vollständiger Name",
      "Email": "E-Mail",
      "Referral Code (Optional)": "Empfehlungscode (optional)",
      "Please Enter a Valid Email !!": "Bitte gültige E-Mail eingeben!!",
      "Password must be at least 3 characters long !!": "Das Passwort muss mindestens 3 Zeichen lang sein!!",
      "Payment in Process !!": "Zahlung wird bearbeitet!!",
      "Select Payment Method !!": "Bitte Zahlungsmethode auswählen!!",
      "Select Payment Method": "Zahlungsmethode auswählen",
      "Loading...": "Lädt...",
      "Select Cancel Reason !!": "Bitte Stornierungsgrund auswählen!!",
      "Active": "Aktiv",
      "Completed": "Abgeschlossen",
      "Go & Book your favorite Event !!": "Buche dein Lieblingsevent!!",
      "Select Reason": "Grund auswählen",
      "Please select the reason for cancellation": "Bitte wähle den Stornierungsgrund aus",
      "Cancel": "Stornieren",
      "View E-Ticket": "E-Ticket ansehen",
      "Financing fell through": "Finanzierung gescheitert",
      "Inspection issues": "Inspektionsprobleme",
      "Change in financial situation": "Änderung der finanziellen Situation",
      "Title issues": "Titelprobleme",
      "Seller changes their mind": "Verkäufer hat seine Meinung geändert",
      "Competing offer": "Konkurrenzangebot",
      "Personal Reasons": "Persönliche Gründe",
      "Others": "Andere",
      "Enter Other Reason": "Anderen Grund eingeben",
      "Please Select User !!": "Bitte Benutzer auswählen!!",
      "Please Write Message !!": "Bitte Nachricht schreiben!!",
      "Send": "Senden",
      "Select User": "Benutzer auswählen",
      "Add Message...": "Nachricht hinzufügen...",
      "Search...": "Suchen...",
      "Please select ticket !!": "Bitte Ticket auswählen!!",
      "Sorry, Favorite List Empty !!": "Entschuldigung, Favoritenliste ist leer!!",
      "Payment Faild !!": "Zahlung fehlgeschlagen!!",
      "Please Upload Photo !!": "Bitte Foto hochladen!!",
      "Enter Name": "Name eingeben",
      "Enter Password": "Passwort eingeben",
      "Add Your Favorite Photo": "Füge dein Lieblingsfoto hinzu",
      "Upload": "Hochladen",
      "Update": "Aktualisieren",
      "Text copied to clipboard !!": "Text in Zwischenablage kopiert!!",
      "E - Ticket": "E-Ticket",
      "Dates": "Daten",
      "Location": "Ort",
      "Booking details": "Buchungsdetails",
      "Phone": "Telefon",
      "Seats": "Sitze",
      "Tax": "Steuer",
      "Total": "Gesamt",
      "Payment Method": "Zahlungsmethode",
      "Transaction ID": "Transaktions-ID",
      "Download Ticket": "Ticket herunterladen",
      "Please Enter Amount !!": "Bitte Betrag eingeben!!",
      "Add Wallet": "Wallet hinzufügen",
      "Your Current Wallet Balance is": "Dein aktueller Wallet-Guthaben ist",
      "Your Recent Transaction": "Deine letzte Transaktion",
      "Amount": "Betrag",
      "Frequently asked questions": "Häufig gestellte Fragen",
      "Helps & FAQs": "Hilfe & FAQs",
      "Today": "Heute",
      "Upcoming": "Bevorstehend",
      "Past": "Vergangen",
      "Review": "Bewertung",
      "Leave a Review": "Bewertung hinterlassen",
      "How was your experience": "Wie war Ihre Erfahrung?",
      "Write Your Review": "Schreiben Sie Ihre Bewertung",
      "Maybe Later": "Vielleicht später",
      "Submit": "Absenden",
      "Your reviewe here..": "Ihre Bewertung hier..",
      "No Any Notification !!": "Keine Benachrichtigungen !!",
      "You added": "Sie haben hinzugefügt",
      "items to": "Elemente zu",
      "favorites": "Favoriten",
      "bookings": "Buchungen",
      "Cancelled": "Storniert",
      "Enable Smart Alerts": "Intelligente Benachrichtigungen aktivieren",
      "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.": "Lassen Sie sich über bevorstehende Buchungen, Änderungen und wichtige Updates direkt über Ihren Browser benachrichtigen.",
      "Ticket Status": "Ticketstatus"
    }
  },
  in: {
    translation: {
      "Free Call": "Panggilan Gratis",
      "Online Support": "Dukungan Online",
      "Our Location": "Lokasi Kami",
      "Language": "Bahasa",
      "Notification": "Notifikasi",
      "Messages": "Pesan",
      "Bookings": "Pemesanan",
      "Favorites": "Favorit",
      "Wallet": "Dompet",
      "Account": "Akun",
      "Log out": "Keluar",
      "Enable Location Services": "Aktifkan Layanan Lokasi",
      "To provide accurate services, please enable your location.": "Untuk memberikan layanan yang akurat, harap aktifkan lokasi Anda.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Izinkan akses lokasi saat diminta. Jika tidak diminta, aktifkan di pengaturan browser Anda.",
      "Refresh the page after enabling.": "Segarkan halaman setelah mengaktifkan.",
      "Enable Now": "Aktifkan Sekarang",
      "Discover amazing event": "Temukan acara menakjubkan",
      "Search here...": "Cari di sini...",
      "Reviews": "Ulasan",
      "Browse by Category": "Jelajahi berdasarkan Kategori",
      "Latest Event": "Acara Terbaru",
      "Just Dropped – Be the First to Book!": "Baru Rilis – Jadilah yang Pertama Memesan!",
      "Nearby Event": "Acara Terdekat",
      "Happening Around You – Don’t Miss Out!": "Sedang Terjadi di Sekitar Anda – Jangan Lewatkan!",
      "Monthly Event": "Acara Bulanan",
      "This Month’s Top Picks – Plan Your Fun!": "Pilihan Terbaik Bulan Ini – Rencanakan Keseruanmu!",
      "View Details": "Lihat Detail",
      "Upcoming Event": "Acara Mendatang",
      "Coming Soon – Save Your Spot Early!": "Segera Hadir – Amankan Tempatmu Lebih Awal!",
      "Instant Ticket Delivery": "Pengiriman Tiket Instan",
      "Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!": "Dapatkan tiket acara Anda langsung melalui email atau SMS—cepat, gratis, dan tanpa ribet!",
      "Easy Cancellations": "Pembatalan Mudah",
      "Change of plans? Cancel or reschedule your booking within 15 days with flexible options.": "Ubah rencana? Batalkan atau jadwalkan ulang pemesanan Anda dalam 15 hari dengan opsi fleksibel.",
      "24/7 Customer Support": "Dukungan Pelanggan 24/7",
      "Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.": "Ada pertanyaan? Tim kami siap membantu Anda 24 jam sehari, 7 hari seminggu.",
      "Secure Payment": "Pembayaran Aman",
      "Book your tickets safely using multiple secure payment methods, including credit and debit cards.": "Pesan tiket Anda dengan aman menggunakan berbagai metode pembayaran aman, termasuk kartu kredit dan debit.",
      "About Company": "Tentang Perusahaan",
      "We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.": "Kami membuat perencanaan acara menjadi sederhana dan tanpa stres. Apakah Anda mengorganisir konser, konferensi, atau pesta pribadi, platform kami menghubungkan Anda dengan tempat dan layanan terbaik untuk mewujudkan visi Anda.",
      "Help Information": "Informasi Bantuan",
      "Shipping Information": "Informasi Pengiriman",
      "Return & Refunds": "Pengembalian & Pengembalian Dana",
      "Payment Options": "Pilihan Pembayaran",
      "FAQ": "FAQ",
      "Terms of Service": "Syarat Layanan",
      "Account Information": "Informasi Akun",
      "Login/Create Accoun": "Masuk/Buat Akun",
      "Track Order": "Lacak Pesanan",
      "Copyright © 2025 Nabhiverse, All Rights Reserved.": "Hak Cipta © 2025 Nabhiverse, Semua Hak Dilindungi.",
      "Home": "Beranda",
      "Event Not Available !!": "Acara Tidak Tersedia !!",
      "Ticket Price": "Harga Tiket",
      "Organized By": "Diselenggarakan Oleh",
      "Attendees": "Peserta",
      "Chat": "Obrolan",
      "About Event": "Tentang Acara",
      "Disclaimer": "Penafian",
      "Artist": "Artis",
      "Facillity": "Fasilitas",
      "Event Prohibited": "Acara Dilarang",
      "Explore": "Jelajahi",
      "Gllery": "Galeri",
      "Video": "Video",
      "Tags": "Tag",
      "Ticket Details": "Detail Tiket",
      "WHAT TICKET WOULD YOU LIKE?": "TIKET APA YANG ANDA INGINKAN?",
      "spots left": "tempat tersisa",
      "PURCHASE": "BELI",
      "Book Now": "Pesan Sekarang",
      "Go home": "Kembali ke Beranda",
      "Event Details": "Detail Acara",
      "Confirm and pay": "Konfirmasi dan bayar",
      "Apply Coupon": "Gunakan Kupon",
      "Apply": "Terapkan",
      "Remove": "Hapus",
      "Pay from wallet": "Bayar dari dompet",
      "Your Balance": "Saldo Anda",
      "Available for Payment": "Tersedia untuk Pembayaran",
      "Price details": "Rincian harga",
      "Price": "Harga",
      "Fee": "Biaya",
      "Coupon": "Kupon",
      "Total Payment": "Total Pembayaran",
      "Confirm": "Konfirmasi",
      "Available coupons": "Kupon tersedia",
      "Expires": "Kadaluarsa",
      "Sign in to Nabhiverse": "Masuk ke Nabhiverse",
      "welcome back Please enter your details.": "Selamat datang kembali, silakan masukkan detail Anda.",
      "Phone Number": "Nomor Telepon",
      "Forgot passowrd?": "Lupa kata sandi?",
      "Reset it": "Reset kata sandi",
      "Sign In": "Masuk",
      "Don't have and account?": "Belum punya akun?",
      "Sign Up": "Daftar",
      "Can't Sign in?": "Tidak bisa masuk?",
      "Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number": "Masukkan nomor ponsel yang terkait dengan akun Anda, dan RideNow akan mengirimkan OTP ke nomor ponsel yang terdaftar",
      "Continue": "Lanjutkan",
      "Return to Sign In": "Kembali ke Masuk",
      "Awesome": "Hebat",
      "We have send the OTP to": "Kami telah mengirim OTP ke",
      "Your OTP": "OTP Anda",
      "VERIFY OTP": "VERIFIKASI OTP",
      "Create A New Password": "Buat Kata Sandi Baru",
      "Passowrd": "Kata Sandi",
      "Confrim Password": "Konfirmasi Kata Sandi",
      "Please Enter Details !!": "Harap Isi Detail !!",
      "Password must be at least 3 characters long!!": "Kata sandi harus minimal 3 karakter!!",
      "Please enter number": "Harap masukkan nomor",
      "OTP send successfully !!": "OTP berhasil dikirim !!",
      "OTP is invalid !!": "OTP tidak valid !!",
      "Enter Password !!": "Masukkan Kata Sandi !!",
      "Not Match Password !!": "Kata Sandi Tidak Cocok !!",
      "Almost there!": "Hampir selesai!",
      "You need to enter 6-digit code that we have send to your mobile number": "Anda perlu memasukkan kode 6 digit yang telah kami kirim ke nomor ponsel Anda",
      "By signing up, you agree to our": "Dengan mendaftar, Anda setuju dengan",
      "and": "dan",
      "Privacy Policy.": "Kebijakan Privasi.",
      "Already have and account?": "Sudah punya akun?",
      "Full Name": "Nama Lengkap",
      "Email": "Email",
      "Referral Code (Optional)": "Kode Referral (Opsional)",
      "Please Enter a Valid Email !!": "Harap Masukkan Email yang Valid !!",
      "Password must be at least 3 characters long !!": "Kata sandi harus minimal 3 karakter !!",
      "Payment in Process !!": "Pembayaran Sedang Diproses !!",
      "Select Payment Method !!": "Pilih Metode Pembayaran !!",
      "Select Payment Method": "Pilih Metode Pembayaran",
      "Loading...": "Memuat...",
      "Select Cancel Reason !!": "Pilih Alasan Pembatalan !!",
      "Active": "Aktif",
      "Completed": "Selesai",
      "Go & Book your favorite Event !!": "Ayo & Pesan Acara Favoritmu !!",
      "Select Reason": "Pilih Alasan",
      "Please select the reason for cancellation": "Harap pilih alasan pembatalan",
      "Cancel": "Batal",
      "View E-Ticket": "Lihat E-Tiket",
      "Financing fell through": "Pembiayaan gagal",
      "Inspection issues": "Masalah inspeksi",
      "Change in financial situation": "Perubahan situasi keuangan",
      "Title issues": "Masalah judul",
      "Seller changes their mind": "Penjual berubah pikiran",
      "Competing offer": "Tawaran bersaing",
      "Personal Reasons": "Alasan Pribadi",
      "Others": "Lainnya",
      "Enter Other Reason": "Masukkan Alasan Lain",
      "Please Select User !!": "Harap Pilih Pengguna !!",
      "Please Write Message !!": "Harap Tulis Pesan !!",
      "Send": "Kirim",
      "Select User": "Pilih Pengguna",
      "Add Message...": "Tambahkan Pesan...",
      "Search...": "Cari...",
      "Please select ticket !!": "Harap pilih tiket !!",
      "Sorry, Favorite List Empty !!": "Maaf, Daftar Favorit Kosong !!",
      "Payment Faild !!": "Pembayaran Gagal !!",
      "Please Upload Photo !!": "Harap Unggah Foto !!",
      "Enter Name": "Masukkan Nama",
      "Enter Password": "Masukkan Kata Sandi",
      "Add Your Favorite Photo": "Tambahkan Foto Favorit Anda",
      "Upload": "Unggah",
      "Update": "Perbarui",
      "Text copied to clipboard !!": "Teks disalin ke clipboard !!",
      "E - Ticket": "E - Tiket",
      "Dates": "Tanggal",
      "Location": "Lokasi",
      "Booking details": "Detail Pemesanan",
      "Phone": "Telepon",
      "Seats": "Kursi",
      "Tax": "Pajak",
      "Total": "Total",
      "Payment Method": "Metode Pembayaran",
      "Transaction ID": "ID Transaksi",
      "Download Ticket": "Unduh Tiket",
      "Please Enter Amount !!": "Harap Masukkan Jumlah !!",
      "Add Wallet": "Tambah Dompet",
      "Your Current Wallet Balance is": "Saldo Dompet Anda Saat Ini adalah",
      "Your Recent Transaction": "Transaksi Terbaru Anda",
      "Amount": "Jumlah",
      "Frequently asked questions": "Pertanyaan yang Sering Diajukan",
      "Helps & FAQs": "Bantuan & FAQ",
      "Today": "Hari ini",
      "Upcoming": "Mendatang",
      "Past": "Lalu",
      "Review": "Ulasan",
      "Leave a Review": "Tinggalkan Ulasan",
      "How was your experience": "Bagaimana pengalaman Anda?",
      "Write Your Review": "Tulis Ulasan Anda",
      "Maybe Later": "Mungkin Nanti",
      "Submit": "Kirim",
      "Your reviewe here..": "Ulasan Anda di sini..",
      "No Any Notification !!": "Tidak Ada Notifikasi!!",
      "You added": "Anda telah menambahkan",
      "items to": "item ke",
      "favorites": "favorit",
      "bookings": "pemesanan",
      "Cancelled": "Dibatalkan",
      "Enable Smart Alerts": "Aktifkan Notifikasi Cerdas",
      "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.": "Izinkan kami memberi tahu Anda tentang pemesanan yang akan datang, perubahan, dan pembaruan penting langsung melalui browser Anda.",
      "Ticket Status": "Status Tiket"
    }
  },
  so: {
    translation: {
      "Free Call": "Gratis Oproep",
      "Online Support": "Aanlyn Ondersteuning",
      "Our Location": "Ons Ligging",
      "Language": "Taal",
      "Notification": "Kennisgewing",
      "Messages": "Boodskappe",
      "Bookings": "Besprekings",
      "Favorites": "Gunstelinge",
      "Wallet": "Beursie",
      "Account": "Rekening",
      "Log out": "Teken uit",
      "Enable Location Services": "Aktiveer Liggingdienste",
      "To provide accurate services, please enable your location.": "Om akkurate dienste te lewer, aktiveer asseblief jou ligging.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Laat liggingtoegang toe wanneer gevra. As jy nie gevra word nie, aktiveer dit in jou blaaier se instellings.",
      "Refresh the page after enabling.": "Herladen die bladsy nadat dit geaktiveer is.",
      "Enable Now": "Aktiveer Nou",
      "Discover amazing event": "Ontdek wonderlike gebeurtenis",
      "Search here...": "Soek hier...",
      "Reviews": "Resensies",
      "Browse by Category": "Blaai volgens Kategorie",
      "Latest Event": "Nuutste Gebeurtenis",
      "Just Dropped – Be the First to Book!": "Pas Gepubliseer – Wees die Eerste om te Bespreek!",
      "Nearby Event": "Nabygeleë Gebeurtenis",
      "Happening Around You – Don’t Miss Out!": "Gebeur rondom jou – Moet dit nie misloop nie!",
      "Monthly Event": "Maandelikse Gebeurtenis",
      "This Month’s Top Picks – Plan Your Fun!": "Hierdie Maand se Topkeuses – Beplan Jou Pret!",
      "View Details": "Sien Besonderhede",
      "Upcoming Event": "Komende Gebeurtenis",
      "Coming Soon – Save Your Spot Early!": "Binnekort Beskikbaar – Bespreek Jou Plek Vroeg!",
      "Instant Ticket Delivery": "Onmiddellike Kaartjie-aflewering",
      "Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!": "Ontvang jou gebeurteniskaartjies onmiddellik via e-pos of SMS – vinnig, gratis en sonder moeite!",
      "Easy Cancellations": "Maklike Kansellasies",
      "Change of plans? Cancel or reschedule your booking within 15 days with flexible options.": "Verander jou planne? Kanselleer of herskeduleer jou bespreking binne 15 dae met buigsame opsies.",
      "24/7 Customer Support": "24/7 Kliëntediens",
      "Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.": "Het jy vrae? Ons span is 24 uur per dag, 7 dae per week beskikbaar om jou by elke stap te help.",
      "Secure Payment": "Veilige Betaling",
      "Book your tickets safely using multiple secure payment methods, including credit and debit cards.": "Bespreek jou kaartjies veilig met verskeie veilige betaalmetodes, insluitend krediet- en debietkaarte.",
      "About Company": "Oor die Maatskappy",
      "We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.": "Ons maak gebeurtenisbeplanning eenvoudig en sonder stres. Of jy nou ’n konsert, konferensie of privaat partytjie reël, ons platform verbind jou met top lokaal en dienste om jou visie te verwesenlik.",
      "Help Information": "Hulpinligting",
      "Shipping Information": "Versendingsinligting",
      "Return & Refunds": "Terugsendings & Terugbetalings",
      "Payment Options": "Betaalopsies",
      "FAQ": "Gereelde Vrae",
      "Terms of Service": "Diensvoorwaardes",
      "Account Information": "Rekeninginligting",
      "Login/Create Accoun": "Meld aan/Skep Rekening",
      "Track Order": "Volg Bestelling",
      "Copyright © 2025 Nabhiverse, All Rights Reserved.": "Kopiereg © 2025 Nabhiverse, Alle Regte Voorbehou.",
      "Home": "Tuis",
      "Event Not Available !!": "Gebeurtenis Nie Beskikbaar Nie!!",
      "Ticket Price": "Kaartjieprys",
      "Organized By": "Gereël Deur",
      "Attendees": "Bywoners",
      "Chat": "Klets",
      "About Event": "Oor die Gebeurtenis",
      "Disclaimer": "Vrywaring",
      "Artist": "Kunstenaar",
      "Facillity": "Fasiliteit",
      "Event Prohibited": "Gebeurtenis Verbied",
      "Explore": "Verken",
      "Gllery": "Galerie",
      "Video": "Video",
      "Tags": "Merkers",
      "Ticket Details": "Kaartjiebesonderhede",
      "WHAT TICKET WOULD YOU LIKE?": "WATTER KAARTJIE WIL JY HÊ?",
      "spots left": "plekke oor",
      "PURCHASE": "KOOP",
      "Book Now": "Bespreek Nou",
      "Go home": "Gaan huis toe",
      "Event Details": "Gebeurtenisbesonderhede",
      "Confirm and pay": "Bevestig en betaal",
      "Apply Coupon": "Gebruik Koepon",
      "Apply": "Gebruik",
      "Remove": "Verwyder",
      "Pay from wallet": "Betaal uit beursie",
      "Your Balance": "Jou Balans",
      "Available for Payment": "Beskikbaar vir Betaling",
      "Price details": "Prysbesonderhede",
      "Price": "Prys",
      "Fee": "Fooi",
      "Coupon": "Koepon",
      "Total Payment": "Totale Betaling",
      "Confirm": "Bevestig",
      "Available coupons": "Beskikbare Koepons",
      "Expires": "Verstryk",
      "Sign in to Nabhiverse": "Meld aan by Nabhiverse",
      "welcome back Please enter your details.": "welkom terug, Voer asseblief jou besonderhede in.",
      "Phone Number": "Telefoonnommer",
      "Forgot passowrd?": "Wagwoord vergeet?",
      "Reset it": "Stel dit terug",
      "Sign In": "Meld Aan",
      "Don't have and account?": "Het jy nie 'n rekening nie?",
      "Sign Up": "Teken Aan",
      "Can't Sign in?": "Kan nie aanmeld nie?",
      "Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number": "Voer die selfoonnommer in wat met jou rekening geassosieer is, en RideNow sal vir jou 'n OTP stuur na jou geregistreerde selfoonnommer",
      "Continue": "Gaan voort",
      "Return to Sign In": "Terug na Aanmelding",
      "Awesome": "Fantasties",
      "We have send the OTP to": "Ons het die OTP gestuur na",
      "Your OTP": "Jou OTP",
      "VERIFY OTP": "VERIFISEER OTP",
      "Create A New Password": "Skep 'n Nuwe Wagwoord",
      "Passowrd": "Wagwoord",
      "Confrim Password": "Bevestig Wagwoord",
      "Please Enter Details !!": "Voer asseblief besonderhede in !!",
      "Password must be at least 3 characters long!!": "Wagwoord moet minstens 3 karakters lank wees!!",
      "Please enter number": "Voer asseblief 'n nommer in",
      "OTP send successfully !!": "OTP suksesvol gestuur !!",
      "OTP is invalid !!": "OTP is ongeldig !!",
      "Enter Password !!": "Voer Wagwoord In !!",
      "Not Match Password !!": "Wagwoorde stem nie ooreen nie !!",
      "Almost there!": "Byna klaar!",
      "You need to enter 6-digit code that we have send to your mobile number": "Jy moet die 6-syferkode invoer wat ons na jou selfoonnommer gestuur het",
      "By signing up, you agree to our": "Deur aan te teken, stem jy in tot ons",
      "and": "en",
      "Privacy Policy.": "Privaatheidsbeleid.",
      "Already have and account?": "Het jy reeds 'n rekening?",
      "Full Name": "Volle Naam",
      "Email": "E-pos",
      "Referral Code (Optional)": "Verwysingskode (Opsioneel)",
      "Please Enter a Valid Email !!": "Voer asseblief 'n geldige e-posadres in !!",
      "Password must be at least 3 characters long !!": "Wagwoord moet minstens 3 karakters lank wees !!",
      "Payment in Process !!": "Betaling in proses !!",
      "Select Payment Method !!": "Kies Betaalmetode !!",
      "Select Payment Method": "Kies Betaalmetode",
      "Loading...": "Laai...",
      "Select Cancel Reason !!": "Kies Kanselleringsrede !!",
      "Active": "Aktief",
      "Completed": "Voltooi",
      "Go & Book your favorite Event !!": "Gaan en bespreek jou gunsteling gebeurtenis !!",
      "Select Reason": "Kies Rede",
      "Please select the reason for cancellation": "Kies asseblief die rede vir kansellasie",
      "Cancel": "Kanselleer",
      "View E-Ticket": "Beskou E-Kaartjie",
      "Financing fell through": "Finansiering het misluk",
      "Inspection issues": "Inspeksieprobleme",
      "Change in financial situation": "Verandering in finansiële situasie",
      "Title issues": "Titelprobleme",
      "Seller changes their mind": "Verkoper verander van plan",
      "Competing offer": "Meddingende aanbod",
      "Personal Reasons": "Persoonlike Redes",
      "Others": "Ander",
      "Enter Other Reason": "Voer Ander Rede In",
      "Please Select User !!": "Kies asseblief gebruiker !!",
      "Please Write Message !!": "Skryf asseblief 'n boodskap !!",
      "Send": "Stuur",
      "Select User": "Kies Gebruiker",
      "Add Message...": "Voeg Boodskap by...",
      "Search...": "Soek...",
      "Please select ticket !!": "Kies asseblief 'n kaartjie !!",
      "Sorry, Favorite List Empty !!": "Jammer, Gunstelinglys is Leeg !!",
      "Payment Faild !!": "Betaling het Misluk !!",
      "Please Upload Photo !!": "Laai asseblief 'n foto op !!",
      "Enter Name": "Voer Naam In",
      "Enter Password": "Voer Wagwoord In",
      "Add Your Favorite Photo": "Voeg Jou Gunsteling Foto By",
      "Upload": "Laai op",
      "Update": "Opdateer",
      "Text copied to clipboard !!": "Teks is na knipbord gekopieer !!",
      "E - Ticket": "E - Kaartjie",
      "Dates": "Datums",
      "Location": "Ligging",
      "Booking details": "Besprekingsbesonderhede",
      "Phone": "Foon",
      "Seats": "SITPLEKKE",
      "Tax": "Belasting",
      "Total": "Totaal",
      "Payment Method": "Betaalmetode",
      "Transaction ID": "Transaksie-ID",
      "Download Ticket": "Laai Kaartjie Af",
      "Please Enter Amount !!": "Voer asseblief Bedrag In !!",
      "Add Wallet": "Voeg Beursie By",
      "Your Current Wallet Balance is": "Jou Huidige Beursiesaldo is",
      "Your Recent Transaction": "Jou Onlangse Transaksie",
      "Amount": "Bedrag",
      "Frequently asked questions": "Gereelde Vrae",
      "Helps & FAQs": "Hulp & Vrae",
      "Today": "Vandag",
      "Upcoming": "Komend",
      "Past": "Verlede",
      "Review": "Resensie",
      "Leave a Review": "Laat 'n Resensie",
      "How was your experience": "Hoe was jou ervaring?",
      "Write Your Review": "Skryf jou Resensie",
      "Maybe Later": "Miskien later",
      "Submit": "Indien",
      "Your reviewe here..": "Jou resensie hier..",
      "No Any Notification !!": "Geen kennisgewing nie!!",
      "You added": "Jy het bygevoeg",
      "items to": "items by",
      "favorites": "gunstelinge",
      "bookings": "besprekings",
      "Cancelled": "Gekanselleer",
      "Enable Smart Alerts": "Skakel Slim Kennisgewings aan",
      "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.": "Laat ons jou in kennis stel van komende besprekings, veranderinge en belangrike opdaterings direk via jou blaaier.",
      "Ticket Status": "Kaartjiestatus"
    }
  },
  tu: {
    translation: {
      "Free Call": "Ücretsiz Arama",
      "Online Support": "Çevrimiçi Destek",
      "Our Location": "Konumumuz",
      "Language": "Dil",
      "Notification": "Bildirim",
      "Messages": "Mesajlar",
      "Bookings": "Rezervasyonlar",
      "Favorites": "Favoriler",
      "Wallet": "Cüzdan",
      "Account": "Hesap",
      "Log out": "Çıkış Yap",
      "Enable Location Services": "Konum Servislerini Etkinleştir",
      "To provide accurate services, please enable your location.": "Doğru hizmetler sunabilmemiz için lütfen konumunuzu etkinleştirin.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "İstendiğinde konum erişimine izin verin. İstenmezse, tarayıcı ayarlarından etkinleştirin.",
      "Refresh the page after enabling.": "Etkinleştirdikten sonra sayfayı yenileyin.",
      "Enable Now": "Şimdi Etkinleştir",
      "Discover amazing event": "Harika etkinlikleri keşfedin",
      "Search here...": "Burada ara...",
      "Reviews": "Yorumlar",
      "Browse by Category": "Kategoriye Göre Göz At",
      "Latest Event": "En Yeni Etkinlik",
      "Just Dropped – Be the First to Book!": "Yeni Yayınlandı – İlk Rezervasyonu Yapan Siz Olun!",
      "Nearby Event": "Yakındaki Etkinlik",
      "Happening Around You – Don’t Miss Out!": "Çevrenizdeki Etkinlikler – Kaçırmayın!",
      "Monthly Event": "Aylık Etkinlik",
      "This Month’s Top Picks – Plan Your Fun!": "Bu Ayın Öne Çıkanları – Eğlenceni Planla!",
      "View Details": "Detayları Görüntüle",
      "Upcoming Event": "Yaklaşan Etkinlik",
      "Coming Soon – Save Your Spot Early!": "Çok Yakında – Erken Rezervasyon Yapın!",
      "Instant Ticket Delivery": "Anında Bilet Teslimi",
      "Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!": "Etkinlik biletlerinizi e-posta veya SMS yoluyla anında alın—hızlı, ücretsiz ve sorunsuz!",
      "Easy Cancellations": "Kolay İptaller",
      "Change of plans? Cancel or reschedule your booking within 15 days with flexible options.": "Planlar mı değişti? Rezervasyonunuzu 15 gün içinde iptal edin veya yeniden planlayın.",
      "24/7 Customer Support": "7/24 Müşteri Desteği",
      "Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.": "Sorularınız mı var? Ekibimiz haftanın 7 günü 24 saat hizmetinizde.",
      "Secure Payment": "Güvenli Ödeme",
      "Book your tickets safely using multiple secure payment methods, including credit and debit cards.": "Biletlerinizi kredi ve banka kartı dahil çeşitli güvenli ödeme yöntemleriyle güvenle satın alın.",
      "About Company": "Şirket Hakkında",
      "We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.": "Etkinlik planlamayı kolay ve stressiz hale getiriyoruz. Konser, konferans veya özel parti düzenliyor olun, platformumuz sizi en iyi mekanlar ve hizmetlerle buluşturur.",
      "Help Information": "Yardım Bilgileri",
      "Shipping Information": "Kargo Bilgileri",
      "Return & Refunds": "İade ve Geri Ödemeler",
      "Payment Options": "Ödeme Seçenekleri",
      "FAQ": "SSS",
      "Terms of Service": "Hizmet Şartları",
      "Account Information": "Hesap Bilgileri",
      "Login/Create Accoun": "Giriş Yap/Hesap Oluştur",
      "Track Order": "Siparişi Takip Et",
      "Copyright © 2025 Nabhiverse, All Rights Reserved.": "Telif Hakkı © 2025 Nabhiverse, Tüm Hakları Saklıdır.",
      "Home": "Ana Sayfa",
      "Event Not Available !!": "Etkinlik Mevcut Değil !!",
      "Ticket Price": "Bilet Fiyatı",
      "Organized By": "Düzenleyen",
      "Attendees": "Katılımcılar",
      "Chat": "Sohbet",
      "About Event": "Etkinlik Hakkında",
      "Disclaimer": "Feragatname",
      "Artist": "Sanatçı",
      "Facillity": "Tesis",
      "Event Prohibited": "Etkinlik Yasaklandı",
      "Explore": "Keşfet",
      "Gllery": "Galeri",
      "Video": "Video",
      "Tags": "Etiketler",
      "Ticket Details": "Bilet Detayları",
      "WHAT TICKET WOULD YOU LIKE?": "HANGİ BİLETİ İSTERSİNİZ?",
      "spots left": "kalan yer",
      "PURCHASE": "SATIN AL",
      "Book Now": "Şimdi Rezervasyon Yap",
      "Go home": "Ana Sayfaya Dön",
      "Event Details": "Etkinlik Detayları",
      "Confirm and pay": "Onayla ve Öde",
      "Apply Coupon": "Kupon Uygula",
      "Apply": "Uygula",
      "Remove": "Kaldır",
      "Pay from wallet": "Cüzdandan Öde",
      "Your Balance": "Bakiyeniz",
      "Available for Payment": "Ödemeye Uygun",
      "Price details": "Fiyat Detayları",
      "Price": "Fiyat",
      "Fee": "Ücret",
      "Coupon": "Kupon",
      "Total Payment": "Toplam Ödeme",
      "Confirm": "Onayla",
      "Available coupons": "Mevcut Kuponlar",
      "Expires": "Son Kullanma",
      "Sign in to Nabhiverse": "Nabhiverse'e Giriş Yap",
      "welcome back Please enter your details.": "Tekrar hoş geldiniz, lütfen bilgilerinizi girin.",
      "Phone Number": "Telefon Numarası",
      "Forgot passowrd?": "Şifrenizi mi unuttunuz?",
      "Reset it": "Sıfırla",
      "Sign In": "Giriş Yap",
      "Don't have and account?": "Hesabınız yok mu?",
      "Sign Up": "Kayıt Ol",
      "Can't Sign in?": "Giriş yapılamıyor mu?",
      "Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number": "Hesabınızla ilişkili cep telefonu numarasını girin, RideNow kayıtlı numaranıza bir OTP gönderecek",
      "Continue": "Devam Et",
      "Return to Sign In": "Giriş Ekranına Dön",
      "Awesome": "Harika",
      "We have send the OTP to": "OTP gönderildi:",
      "Your OTP": "OTP Kodunuz",
      "VERIFY OTP": "OTP DOĞRULA",
      "Create A New Password": "Yeni Bir Şifre Oluştur",
      "Passowrd": "Şifre",
      "Confrim Password": "Şifreyi Onayla",
      "Please Enter Details !!": "Lütfen bilgileri giriniz !!",
      "Password must be at least 3 characters long!!": "Şifre en az 3 karakter uzunluğunda olmalıdır!!",
      "Please enter number": "Lütfen bir numara girin",
      "OTP send successfully !!": "OTP başarıyla gönderildi !!",
      "OTP is invalid !!": "OTP geçersiz !!",
      "Enter Password !!": "Şifreyi giriniz !!",
      "Not Match Password !!": "Şifreler uyuşmuyor !!",
      "Almost there!": "Neredeyse bitti!",
      "You need to enter 6-digit code that we have send to your mobile number": "Cep telefonunuza gönderdiğimiz 6 haneli kodu girmeniz gerekiyor",
      "By signing up, you agree to our": "Kayıt olarak şunları kabul ediyorsunuz:",
      "and": "ve",
      "Privacy Policy.": "Gizlilik Politikası.",
      "Already have and account?": "Zaten bir hesabınız var mı?",
      "Full Name": "Ad Soyad",
      "Email": "E-posta",
      "Referral Code (Optional)": "Referans Kodu (İsteğe Bağlı)",
      "Please Enter a Valid Email !!": "Lütfen geçerli bir e-posta giriniz !!",
      "Password must be at least 3 characters long !!": "Şifre en az 3 karakter olmalıdır !!",
      "Payment in Process !!": "Ödeme İşleniyor !!",
      "Select Payment Method !!": "Lütfen ödeme yöntemini seçiniz !!",
      "Select Payment Method": "Ödeme Yöntemini Seç",
      "Loading...": "Yükleniyor...",
      "Select Cancel Reason !!": "İptal Sebebini Seçiniz !!",
      "Active": "Aktif",
      "Completed": "Tamamlandı",
      "Go & Book your favorite Event !!": "Git ve favori etkinliğini rezerve et !!",
      "Select Reason": "Sebep Seçin",
      "Please select the reason for cancellation": "Lütfen iptal sebebini seçiniz",
      "Cancel": "İptal Et",
      "View E-Ticket": "E-Bileti Görüntüle",
      "Financing fell through": "Finansman gerçekleşmedi",
      "Inspection issues": "Denetim sorunları",
      "Change in financial situation": "Mali durumda değişiklik",
      "Title issues": "Başlık sorunları",
      "Seller changes their mind": "Satıcı fikrini değiştirdi",
      "Competing offer": "Rekabetçi teklif",
      "Personal Reasons": "Kişisel Sebepler",
      "Others": "Diğer",
      "Enter Other Reason": "Diğer Sebebi Giriniz",
      "Please Select User !!": "Lütfen kullanıcı seçiniz !!",
      "Please Write Message !!": "Lütfen mesaj yazınız !!",
      "Send": "Gönder",
      "Select User": "Kullanıcı Seç",
      "Add Message...": "Mesaj Ekle...",
      "Search...": "Ara...",
      "Please select ticket !!": "Lütfen bilet seçiniz !!",
      "Sorry, Favorite List Empty !!": "Üzgünüz, Favori Listesi Boş !!",
      "Payment Faild !!": "Ödeme Başarısız Oldu !!",
      "Please Upload Photo !!": "Lütfen fotoğraf yükleyiniz !!",
      "Enter Name": "Adınızı Girin",
      "Enter Password": "Şifreyi Girin",
      "Add Your Favorite Photo": "Favori Fotoğrafını Ekle",
      "Upload": "Yükle",
      "Update": "Güncelle",
      "Text copied to clipboard !!": "Metin panoya kopyalandı !!",
      "E - Ticket": "E - Bilet",
      "Dates": "Tarihler",
      "Location": "Konum",
      "Booking details": "Rezervasyon Detayları",
      "Phone": "Telefon",
      "Seats": "Koltuklar",
      "Tax": "Vergi",
      "Total": "Toplam",
      "Payment Method": "Ödeme Yöntemi",
      "Transaction ID": "İşlem Numarası",
      "Download Ticket": "Bileti İndir",
      "Please Enter Amount !!": "Lütfen Tutar Giriniz !!",
      "Add Wallet": "Cüzdan Ekle",
      "Your Current Wallet Balance is": "Mevcut Cüzdan Bakiyeniz:",
      "Your Recent Transaction": "Son İşleminiz",
      "Amount": "Tutar",
      "Frequently asked questions": "Sıkça Sorulan Sorular",
      "Helps & FAQs": "Yardım ve SSS",
      "Today": "Bugün",
      "Upcoming": "Yaklaşan",
      "Past": "Geçmiş",
      "Review": "Yorum",
      "Leave a Review": "Yorum Yap",
      "How was your experience": "Deneyiminiz nasıldı?",
      "Write Your Review": "Yorumunuzu Yazın",
      "Maybe Later": "Belki Sonra",
      "Submit": "Gönder",
      "Your reviewe here..": "Yorumunuz buraya..",
      "No Any Notification !!": "Hiçbir Bildirim Yok!!",
      "You added": "Şunu eklediniz",
      "items to": "öğeleri şuraya",
      "favorites": "favoriler",
      "bookings": "rezervasyonlar",
      "Cancelled": "İptal edildi",
      "Enable Smart Alerts": "Akıllı Uyarıları Etkinleştir",
      "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.": "Yaklaşan rezervasyonlar, değişiklikler ve önemli güncellemeler hakkında sizi doğrudan tarayıcınız üzerinden bilgilendirelim.",
      "Ticket Status": "Bilet Durumu"
    }
  },
  中國: {
    translation: {
      "Free Call": "免费通话",
      "Online Support": "在线支持",
      "Our Location": "我们的地址",
      "Language": "语言",
      "Notification": "通知",
      "Messages": "消息",
      "Bookings": "预订",
      "Favorites": "收藏夹",
      "Wallet": "钱包",
      "Account": "账户",
      "Log out": "退出登录",
      "Enable Location Services": "启用定位服务",
      "To provide accurate services, please enable your location.": "为提供准确服务，请启用您的定位。",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "请在系统提示时允许定位访问。如未提示，请在浏览器设置中启用。",
      "Refresh the page after enabling.": "启用后请刷新页面。",
      "Enable Now": "立即启用",
      "Discover amazing event": "发现精彩活动",
      "Search here...": "在此搜索...",
      "Reviews": "评价",
      "Browse by Category": "按类别浏览",
      "Latest Event": "最新活动",
      "Just Dropped – Be the First to Book!": "刚刚发布 – 抢先预订！",
      "Nearby Event": "附近活动",
      "Happening Around You – Don’t Miss Out!": "正在发生 – 不要错过！",
      "Monthly Event": "本月活动",
      "This Month’s Top Picks – Plan Your Fun!": "本月推荐 – 安排乐趣时光！",
      "View Details": "查看详情",
      "Upcoming Event": "即将开始",
      "Coming Soon – Save Your Spot Early!": "敬请期待 – 提前预留！",
      "Instant Ticket Delivery": "即时送票",
      "Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!": "通过电子邮件或短信即时获取活动票——快速、免费、省心！",
      "Easy Cancellations": "轻松退订",
      "Change of plans? Cancel or reschedule your booking within 15 days with flexible options.": "计划有变？15天内灵活取消或改签。",
      "24/7 Customer Support": "全天候客服",
      "Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.": "有疑问？我们的团队全年无休，随时为您服务。",
      "Secure Payment": "安全支付",
      "Book your tickets safely using multiple secure payment methods, including credit and debit cards.": "使用多种安全支付方式（如信用卡、借记卡），安全订票。",
      "About Company": "关于我们",
      "We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.": "我们使活动策划变得简单无忧。无论是音乐会、会议还是私人聚会，我们的平台都能为您连接优质场地与服务，助您梦想成真。",
      "Help Information": "帮助信息",
      "Shipping Information": "配送信息",
      "Return & Refunds": "退换货与退款",
      "Payment Options": "支付选项",
      "FAQ": "常见问题",
      "Terms of Service": "服务条款",
      "Account Information": "账号信息",
      "Login/Create Accoun": "登录/创建账号",
      "Track Order": "订单追踪",
      "Copyright © 2025 Nabhiverse, All Rights Reserved.": "版权 © 2025 Nabhiverse，保留所有权利。",
      "Home": "首页",
      "Event Not Available !!": "活动不可用!!",
      "Ticket Price": "票价",
      "Organized By": "主办方",
      "Attendees": "参与人数",
      "Chat": "聊天",
      "About Event": "关于本次活动",
      "Disclaimer": "免责声明",
      "Artist": "艺术家",
      "Facillity": "设施",
      "Event Prohibited": "活动禁止事项",
      "Explore": "探索",
      "Gllery": "画廊",
      "Video": "视频",
      "Tags": "标签",
      "Ticket Details": "票务详情",
      "WHAT TICKET WOULD YOU LIKE?": "您想要哪种票？",
      "spots left": "剩余名额",
      "PURCHASE": "购买",
      "Book Now": "立即预订",
      "Go home": "返回首页",
      "Event Details": "活动详情",
      "Confirm and pay": "确认并支付",
      "Apply Coupon": "使用优惠券",
      "Apply": "应用",
      "Remove": "移除",
      "Pay from wallet": "从钱包支付",
      "Your Balance": "您的余额",
      "Available for Payment": "可用于付款",
      "Price details": "价格明细",
      "Price": "价格",
      "Fee": "费用",
      "Coupon": "优惠券",
      "Total Payment": "总支付",
      "Confirm": "确认",
      "Available coupons": "可用优惠券",
      "Expires": "截至",
      "Sign in to Nabhiverse": "登录 Nabhiverse",
      "welcome back Please enter your details.": "欢迎回来，请输入您的信息。",
      "Phone Number": "电话号码",
      "Forgot passowrd?": "忘记密码？",
      "Reset it": "重置密码",
      "Sign In": "登录",
      "Don't have and account?": "还没有账号？",
      "Sign Up": "注册",
      "Can't Sign in?": "无法登录？",
      "Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number": "请输入您账户绑定的手机号码，RideNow 将向您注册的手机号发送验证码。",
      "Continue": "继续",
      "Return to Sign In": "返回登录",
      "Awesome": "太棒了",
      "We have send the OTP to": "我们已发送验证码至",
      "Your OTP": "您的验证码",
      "VERIFY OTP": "验证验证码",
      "Create A New Password": "创建新密码",
      "Passowrd": "密码",
      "Confrim Password": "确认密码",
      "Please Enter Details !!": "请输入详细信息！！",
      "Password must be at least 3 characters long!!": "密码至少需要3个字符！！",
      "Please enter number": "请输入号码",
      "OTP send successfully !!": "验证码发送成功！！",
      "OTP is invalid !!": "验证码无效！！",
      "Enter Password !!": "请输入密码！！",
      "Not Match Password !!": "密码不匹配！！",
      "Almost there!": "快完成了！",
      "You need to enter 6-digit code that we have send to your mobile number": "请输入我们发送到您手机的6位验证码",
      "By signing up, you agree to our": "注册即表示您同意我们的",
      "and": "和",
      "Privacy Policy.": "隐私政策。",
      "Already have and account?": "已经有账号？",
      "Full Name": "全名",
      "Email": "邮箱",
      "Referral Code (Optional)": "推荐码（可选）",
      "Please Enter a Valid Email !!": "请输入有效的邮箱地址！！",
      "Password must be at least 3 characters long !!": "密码长度必须至少为3个字符！！",
      "Payment in Process !!": "付款处理中！！",
      "Select Payment Method !!": "请选择支付方式！！",
      "Select Payment Method": "选择支付方式",
      "Loading...": "加载中...",
      "Select Cancel Reason !!": "请选择取消原因！！",
      "Active": "进行中",
      "Completed": "已完成",
      "Go & Book your favorite Event !!": "快去预订你喜欢的活动吧！！",
      "Select Reason": "选择原因",
      "Please select the reason for cancellation": "请选择取消原因",
      "Cancel": "取消",
      "View E-Ticket": "查看电子票",
      "Financing fell through": "融资未成功",
      "Inspection issues": "检查问题",
      "Change in financial situation": "财务状况变化",
      "Title issues": "产权问题",
      "Seller changes their mind": "卖方反悔",
      "Competing offer": "出现更好报价",
      "Personal Reasons": "个人原因",
      "Others": "其他",
      "Enter Other Reason": "输入其他原因",
      "Please Select User !!": "请选择用户！！",
      "Please Write Message !!": "请输入消息！！",
      "Send": "发送",
      "Select User": "选择用户",
      "Add Message...": "添加消息...",
      "Search...": "搜索...",
      "Please select ticket !!": "请选择票券！！",
      "Sorry, Favorite List Empty !!": "抱歉，收藏列表为空！！",
      "Payment Faild !!": "支付失败！！",
      "Please Upload Photo !!": "请上传照片！！",
      "Enter Name": "输入姓名",
      "Enter Password": "输入密码",
      "Add Your Favorite Photo": "添加你喜欢的照片",
      "Upload": "上传",
      "Update": "更新",
      "Text copied to clipboard !!": "文本已复制到剪贴板！！",
      "E - Ticket": "电子票",
      "Dates": "日期",
      "Location": "地点",
      "Booking details": "预订详情",
      "Phone": "电话",
      "Seats": "座位",
      "Tax": "税费",
      "Total": "总计",
      "Payment Method": "支付方式",
      "Transaction ID": "交易编号",
      "Download Ticket": "下载票券",
      "Please Enter Amount !!": "请输入金额！！",
      "Add Wallet": "添加钱包",
      "Your Current Wallet Balance is": "您当前的钱包余额是",
      "Your Recent Transaction": "您最近的交易",
      "Amount": "金额",
      "Frequently asked questions": "常见问题",
      "Helps & FAQs": "帮助与常见问题",
      "Today": "今天",
      "Upcoming": "即将到来",
      "Past": "过去",
      "Review": "評論",
      "Leave a Review": "留下評論",
      "How was your experience": "您的體驗如何?",
      "Write Your Review": "寫下您的評論",
      "Maybe Later": "也許稍後",
      "Submit": "提交",
      "Your reviewe here..": "您的評論在這裡..",
      "No Any Notification !!": "沒有任何通知！！",
      "You added": "您已添加",
      "items to": "项目到",
      "favorites": "收藏夹",
      "bookings": "预订",
      "Cancelled": "已取消",
      "Enable Smart Alerts": "启用智能提醒",
      "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.": "让我们通过您的浏览器直接通知您即将到来的预订、变更和重要更新。",
      "Ticket Status": "票务状态"
    }
  },
};

const savedLanguage = localStorage.getItem('I18') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
